import { PERMISSION, SECTION } from './permission.enum';

export const ROUTE_PERMISSIONS = {
	// -----------------------------------------------------
	// MAIN: DASHBOARD
	// -----------------------------------------------------
	DASHBOARD: [SECTION.DASHBOARD, PERMISSION.READ_DASHBOARD],

	// -----------------------------------------------------
	// MAIN: BENEFIT_DOC_CLAIM_REQ
	// -----------------------------------------------------
	BENEFIT_DOC_CLAIM_REQ: [
		SECTION.BENEFIT_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_BENEFIT_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_BENEFIT_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_BENEFIT_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_BENEFIT_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_BENEFIT_DOC_CLAIM_REQ,
	],

	// -----------------------------------------------------
	// MAIN: inspection request
	// -----------------------------------------------------
	INSPECTION_REQUEST: [
		SECTION.INSPECTION_REQUEST,
		PERMISSION.READ_INSPECT_REQ,
		PERMISSION.ALLOW_CREATE_INSPECT_REQ,
		PERMISSION.ALLOW_EDIT_INSPECT_REQ,
		PERMISSION.ALLOW_DELETE_INSPECT_REQ,
	],
	INSPECTION_RESULT: [
		SECTION.INSPECTION_RESULT,
		PERMISSION.READ_INSPECT_RESULT,
	],

	// -----------------------------------------------------
	// MAIN: PRIMARY INFO
	// -----------------------------------------------------
	PRIMARY_WI_REQUEST: [
		SECTION.PRIMARY_WI_REGISTRATION,
		PERMISSION.ALLOW_CREATE_WI_REQ,
		SECTION.PRIMARY_WI_VALIDATION,
		PERMISSION.READ_WI_REQ,
		PERMISSION.ALLOW_ACCEPT_WI_REQ,
		PERMISSION.ALLOW_RETURN_WI_REQ,
		PERMISSION.ALLOW_REJECT_WI_REQ,
		PERMISSION.ALLOW_EDIT_WI_REQ,
		PERMISSION.ALLOW_ALLOCATE_WI_REQ,
		SECTION.MERGE_SEPARATE_VICTIM,
		PERMISSION.ALLOW_MERGE_SEPARATE_WI_VICTIM,
	],

	// -----------------------------------------------------
	// MAIN: PRIMARY INFO
	// -----------------------------------------------------
	TEMP_WI_VICTIM: [
		SECTION.TEMP_WI_VICTIM,
		PERMISSION.READ_TEMP_WI_VICTIM,
		PERMISSION.ALLOW_CREATE_TEMP_WI_VICTIM,
		PERMISSION.ALLOW_EDIT_TEMP_WI_VICTIM,
		PERMISSION.ALLOW_TRANSFER_TEMP_WI_VICTIM,
		PERMISSION.ALLOW_COMPLETE_TEMP_WI_VICTIM,
	],

	// -----------------------------------------------------
	// MAIN: RETREATMENT REQUEST
	// -----------------------------------------------------
	RETREATMENT_REQUEST: [
		SECTION.RETREATMENT_REQUEST,
		PERMISSION.ALLOW_CREATE_RETREAT_REQ,
		PERMISSION.READ_RETREAT_REQ,
		PERMISSION.ALLOW_ACCEPT_RETREAT_REQ,
		PERMISSION.ALLOW_RETURN_RETREAT_REQ,
		PERMISSION.ALLOW_REJECT_RETREAT_REQ,
		PERMISSION.ALLOW_EDIT_RETREAT_REQ,
		PERMISSION.ALLOW_ALLOCATE_RETREAT_REQ,
	],
	// -----------------------------------------------------
	// MAIN: CLAIM REPORT
	// -----------------------------------------------------
	CLAIM_REQUEST: [
		SECTION.CLAIM_TEMP_REQUEST,
		PERMISSION.READ_CLAIM_TEMP_REQ,
		PERMISSION.ALLOW_CREATE_CLAIM_TEMP_REQ,
		PERMISSION.ALLOW_ACCEPT_CLAIM_TEMP_REQ,
		PERMISSION.ALLOW_RETURN_CLAIM_TEMP_REQ,
		PERMISSION.ALLOW_REJECT_CLAIM_TEMP_REQ,
		PERMISSION.ALLOW_EDIT_CLAIM_TEMP_REQ,
		PERMISSION.ALLOW_ALLOCATE_CLAIM_TEMP_REQ,

		SECTION.CLAIM_REQUEST,
		PERMISSION.READ_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_CLAIM_REQ,
		PERMISSION.ALLOW_TRANSFER_TO_DOCTOR,
		PERMISSION.ALLOW_TRANSFER_TO_CALCULATOR,
	],
	// -----------------------------------------------------
	// MAIN: DAILY INCOME RECORD
	// -----------------------------------------------------
	DAILY_INCOME_RECORD: [
		SECTION.DAILY_INCOME_RECORD,
		PERMISSION.READ_DAILY_INCOME_REC,
		PERMISSION.ALLOW_CREATE_DAILY_INCOME_REC,
	],
	// -----------------------------------------------------
	// MAIN: Benefit Claim Request
	// -----------------------------------------------------
	BENEFIT_CLAIM_REQUEST_HC: [
		SECTION.MEDICAL_CLAIM_REQUEST,
		PERMISSION.READ_MEDICAL_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_MEDICAL_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_MEDICAL_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_MEDICAL_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_MEDICAL_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_MEDICAL_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_MEDICAL_DOC_CLAIM_REQ,

		SECTION.TEMPORARY_CLAIM_REQUEST,
		PERMISSION.READ_TEMP_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_TEMP_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_TEMP_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_TEMP_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_TEMP_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_TEMP_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_TEMP_DOC_CLAIM_REQ,
	],

	// -----------------------------------------------------
	// MAIN: svv inspection request
	// -----------------------------------------------------
	SVV_INSPECTION: [
		//SECTION.SVV_INSPECTION_REQUEST,
		PERMISSION.READ_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_CREATE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_EDIT_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_DELETE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_SUBMIT_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_ACCEPT_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_REJECT_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_RETURN_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_ALLOCATE_SVV_INSPECT_REQ,

		//SECTION.SVV_INSPECTION_RESULT,
		PERMISSION.READ_SVV_INSPECT_RESULT,


	],

	// -----------------------------------------------------
	// MAIN: PERMANENT REQUEST NOTE
	// -----------------------------------------------------
	PERMANENT_REQUEST_NOTE: [
		PERMISSION.READ_PERMANENT_REQUEST_NOTE,
		PERMISSION.ALLOW_CREATE_PERMANENT_REQUEST_NOTE,
		PERMISSION.ALLOW_ACCEPT_PERMANENT_REQUEST_NOTE,
		PERMISSION.ALLOW_RETURN_PERMANENT_REQUEST_NOTE,
		PERMISSION.ALLOW_REJECT_PERMANENT_REQUEST_NOTE,
		PERMISSION.ALLOW_EDIT_PERMANENT_REQUEST_NOTE,
		PERMISSION.ALLOW_ALLOCATE_PERMANENT_REQUEST_NOTE,
	],

	// -----------------------------------------------------
	// MAIN: PERMANENT REQUEST VALUATION
	// -----------------------------------------------------
	PERMANENT_REQUEST_VALUATION: [
		PERMISSION.READ_PERMANENT_REQUEST_VALUATION,
		PERMISSION.ALLOW_CREATE_PERMANENT_REQUEST_VALUATION,
		PERMISSION.ALLOW_ACCEPT_PERMANENT_REQUEST_VALUATION,
		PERMISSION.ALLOW_RETURN_PERMANENT_REQUEST_VALUATION,
		PERMISSION.ALLOW_REJECT_PERMANENT_REQUEST_VALUATION,
		PERMISSION.ALLOW_EDIT_PERMANENT_REQUEST_VALUATION,
		PERMISSION.ALLOW_ALLOCATE_PERMANENT_REQUEST_VALUATION,
	],

	// -----------------------------------------------------
	// MAIN: DOCTOR DOCUMENT REQUEST
	// -----------------------------------------------------
	DOCTOR_DOCUMENT_REQUEST: [
		SECTION.DOCTOR_DOCUMENT_REQUEST,
		PERMISSION.READ_DOCTOR_DOC_REQ,
		PERMISSION.ALLOW_CREATE_DOCTOR_DOC_REQ,
		PERMISSION.ALLOW_EDIT_DOCTOR_DOC_REQ,
		PERMISSION.ALLOW_DELETE_DOCTOR_DOC_REQ,
	],

	// SVV_INSPECTION_RESULT: [

	// ],

	BENEFIT_CLAIM_REQUEST: [
		SECTION.MEDICAL_CLAIM_REQUEST,
		PERMISSION.READ_MEDICAL_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_MEDICAL_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_MEDICAL_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_MEDICAL_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_MEDICAL_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_MEDICAL_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_MEDICAL_CLAIM_REQ,

		SECTION.TEMPORARY_CLAIM_REQUEST,
		PERMISSION.READ_TEMP_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_TEMP_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_TEMP_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_TEMP_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_TEMP_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_TEMP_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_TEMP_CLAIM_REQ,

		SECTION.PERMANENT_CLAIM_REQUEST,
		PERMISSION.READ_PERM_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_PERM_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_PERM_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_PERM_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_PERM_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_PERM_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_PERM_CLAIM_REQ,

		SECTION.ALLOWANCE_CLAIM_REQUEST,
		PERMISSION.READ_ALLOW_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_ALLOW_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_ALLOW_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_ALLOW_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_ALLOW_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_ALLOW_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_ALLOW_CLAIM_REQ,

		SECTION.SURVIVAL_CLAIM_REQUEST,
		PERMISSION.READ_SURVIVAL_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_SURVIVAL_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_SURVIVAL_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_SURVIVAL_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_SURVIVAL_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_SURVIVAL_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_SURVIVAL_CLAIM_REQ,

		SECTION.CALCULATE_CLAIM_REQUEST,
		PERMISSION.READ_CALCULATE_REQ,
		PERMISSION.ALLOW_CREATE_CALCULATE_REQ,
		PERMISSION.ALLOW_ACCEPT_CALCULATE_REQ,
		PERMISSION.ALLOW_RETURN_CALCULATE_REQ,
		PERMISSION.ALLOW_REJECT_CALCULATE_REQ,
		PERMISSION.ALLOW_EDIT_CALCULATE_REQ,
		PERMISSION.ALLOW_ALLOCATE_CALCULATE_REQ,
	],
	// -----------------------------------------------------
	// MAIN: PRINT INFO
	// -----------------------------------------------------
	PRINT_INFO: [
		SECTION.PRINT_INFO,
		PERMISSION.READ_PRINT_INFO_REQ,
		PERMISSION.ALLOW_CREATE_PRINT_INFO_REQ,
		PERMISSION.ALLOW_ACCEPT_PRINT_INFO_REQ,
		PERMISSION.ALLOW_RETURN_PRINT_INFO_REQ,
		PERMISSION.ALLOW_REJECT_PRINT_INFO_REQ,
		PERMISSION.ALLOW_EDIT_PRINT_INFO_REQ,
		PERMISSION.ALLOW_ALLOCATE_PRINT_INFO_REQ,
	],

	// -----------------------------------------------------
	// MAIN: REQUEST INFO
	// -----------------------------------------------------

	REQUEST_INFO: [
		SECTION.REQUEST_INFO,
		PERMISSION.READ_BNV_REQ,
		PERMISSION.ALLOW_CREATE_BNV_REQ,
		PERMISSION.ALLOW_EDIT_BNV_REQ,
		PERMISSION.ALLOW_ACCEPT_BNV_REQ,
		PERMISSION.ALLOW_RETURN_BNV_REQ,
		PERMISSION.ALLOW_REJECT_BNV_REQ,
		PERMISSION.ALLOW_ALLOCATE_BNV_REQ,
		// PERMISSION.ALLOW_APPROVE_BNV_REQ,
		// PERMISSION.READ_BNV_ASSIGN,

	],

	// -----------------------------------------------------
	// MAIN: Benefit Approval Print
	// -----------------------------------------------------
	BENEFIT_APPROVAL: [
		SECTION.BENEFIT_APPROVAL_PRINT,
		PERMISSION.READ_BENEFIT_CONFIRM_REQ,
		PERMISSION.READ_BNC_REQ,

		PERMISSION.ALLOW_CREATE_BNC_REQ,
		PERMISSION.ALLOW_EDIT_BNC_REQ,
		PERMISSION.ALLOW_ACCEPT_BNC_REQ,
		PERMISSION.ALLOW_RETURN_BNC_REQ,
		PERMISSION.ALLOW_REJECT_BNC_REQ,
		PERMISSION.ALLOW_ALLOCATE_BNC_REQ,
		// PERMISSION.ALLOW_APPROVE_BNC_REQ,
		// PERMISSION.READ_BNC_ASSIGN,


		PERMISSION.ALLOW_APPROVE_BENEFIT_APPROVAL_REQ,
		PERMISSION.READ_BENEFIT_CONFIRM_RECEIVER_REQ,
		PERMISSION.ALLOW_CREATE_BENEFIT_CONFIRM_RECEIVER_REQ,
		PERMISSION.ALLOW_ACCEPT_BENEFIT_CONFIRM_RECEIVER_REQ,
		PERMISSION.ALLOW_RETURN_BENEFIT_CONFIRM_RECEIVER_REQ,
		PERMISSION.ALLOW_REJECT_BENEFIT_CONFIRM_RECEIVER_REQ,
		PERMISSION.ALLOW_EDIT_BENEFIT_CONFIRM_RECEIVER_REQ,
		PERMISSION.ALLOW_ALLOCATE_BENEFIT_CONFIRM_RECEIVER_REQ,

		SECTION.BENEFIT_APPROVAL_YEARLY_REPORT,
		PERMISSION.READ_BENEFIT_CONFIRM_YEARLY_REPORT_REQ,
		PERMISSION.ALLOW_CREATE_BENEFIT_CONFIRM_YEARLY_REPORT_REQ,
		PERMISSION.ALLOW_ACCEPT_BENEFIT_CONFIRM_YEARLY_REPORT_REQ,
		PERMISSION.ALLOW_RETURN_BENEFIT_CONFIRM_YEARLY_REPORT_REQ,
		PERMISSION.ALLOW_REJECT_BENEFIT_CONFIRM_YEARLY_REPORT_REQ,
		PERMISSION.ALLOW_EDIT_BENEFIT_CONFIRM_YEARLY_REPORT_REQ,
		PERMISSION.ALLOW_ALLOCATE_BENEFIT_CONFIRM_YEARLY_REPORT_REQ,
	],

	// -----------------------------------------------------
	// MAIN: Monthly Payment
	// -----------------------------------------------------
	// SUB: PERMANENT MONTHLY PAYMENT
	PERMANENT_MONTHLY_PAYMENT: [
		SECTION.PERMANENT_MPP,
		PERMISSION.READ_PERM_MPP_REQ,
		PERMISSION.ALLOW_CREATE_PERM_MPP_REQ,
		PERMISSION.ALLOW_EDIT_PERM_MPP_REQ,
		PERMISSION.ALLOW_ACCEPT_PERM_MPP_REQ,
		PERMISSION.ALLOW_RETURN_PERM_MPP_REQ,
		PERMISSION.ALLOW_REJECT_PERM_MPP_REQ,
		PERMISSION.ALLOW_ALLOCATE_PERM_MPP_REQ,
		PERMISSION.ALLOW_APPROVED_PERM_MPP_REQ,

		SECTION.PERMANENT_INFLATION,
		PERMISSION.READ_PERM_INFLATION_REQ,
		PERMISSION.ALLOW_CREATE_PERM_INFLATION_REQ,
		PERMISSION.ALLOW_EDIT_PERM_INFLATION_REQ,
		PERMISSION.ALLOW_ACCEPT_PERM_INFLATION_REQ,
		PERMISSION.ALLOW_RETURN_PERM_INFLATION_REQ,
		PERMISSION.ALLOW_REJECT_PERM_INFLATION_REQ,
		PERMISSION.ALLOW_ALLOCATE_PERM_INFLATION_REQ,

		SECTION.PERMANENT_REEVALUATE,
		PERMISSION.READ_PERM_REEVALUATE_REQ,
		PERMISSION.ALLOW_CREATE_PERM_REEVALUATE_REQ,

		SECTION.PERMANENT_PAYMENT_DEDUCT,
		PERMISSION.READ_PERM_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_CREATE_PERM_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_EDIT_PERM_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_ACCEPT_PERM_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_RETURN_PERM_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_REJECT_PERM_PAYMENT_DEDUCT_REQ
	],

	// SUB: PERMANENT MONTHLY PAYMENT
	SURVIVAL_MONTHLY_PAYMENT: [
		SECTION.SURVIVAL_MPP,
		PERMISSION.READ_SURVIVAL_MPP_REQ,
		PERMISSION.ALLOW_CREATE_SURVIVAL_MPP_REQ,
		PERMISSION.ALLOW_EDIT_SURVIVAL_MPP_REQ,
		PERMISSION.ALLOW_ACCEPT_SURVIVAL_MPP_REQ,
		PERMISSION.ALLOW_RETURN_SURVIVAL_MPP_REQ,
		PERMISSION.ALLOW_REJECT_SURVIVAL_MPP_REQ,
		PERMISSION.ALLOW_ALLOCATE_SURVIVAL_MPP_REQ,
		PERMISSION.ALLOW_APPROVED_SURVIVAL_MPP_REQ,

		SECTION.SURVIVAL_REEVALUATE,
		PERMISSION.READ_SURVIVAL_REEVALUATE_REQ,
		PERMISSION.ALLOW_CREATE_SURVIVAL_REEVALUATE_REQ,

		SECTION.SURVIVAL_PAYMENT_DEDUCT,
		PERMISSION.READ_SURVIVAL_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_CREATE_SURVIVAL_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_EDIT_SURVIVAL_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_ACCEPT_SURVIVAL_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_RETURN_SURVIVAL_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_REJECT_SURVIVAL_PAYMENT_DEDUCT_REQ
	],

	// SUB: MONTHLY PAYMENT NOTE
	MONTHLY_PAYMENT_NOTE: [
		SECTION.PAYMENT_NOTE,
		PERMISSION.READ_MONTHLY_PAYMENT_NOTE_REQ,
		PERMISSION.ALLOW_CREATE_MONTHLY_PAYMENT_NOTE_REQ,
		PERMISSION.ALLOW_EDIT_MONTHLY_PAYMENT_NOTE_REQ,
		PERMISSION.ALLOW_ACCEPT_MONTHLY_PAYMENT_NOTE_REQ,
		PERMISSION.ALLOW_RETURN_MONTHLY_PAYMENT_NOTE_REQ,
		PERMISSION.ALLOW_REJECT_MONTHLY_PAYMENT_NOTE_REQ,
		PERMISSION.ALLOW_ALLOCATE_MONTHLY_PAYMENT_NOTE_REQ,
	],

	// SUB: MONTHLY PAYMENT NOTE CONFIRM
	MONTHLY_PAYMENT_NOTE_CONFIRM: [
		SECTION.PAYMENT_NOTE_CONFIRM,
		PERMISSION.READ_MONTHLY_PAYMENT_NOTE_CONFIRM_REQ,
		PERMISSION.ALLOW_CREATE_MONTHLY_PAYMENT_NOTE_CONFIRM_REQ,
		PERMISSION.ALLOW_EDIT_MONTHLY_PAYMENT_NOTE_CONFIRM_REQ,
		PERMISSION.ALLOW_ACCEPT_MONTHLY_PAYMENT_NOTE_CONFIRM_REQ,
		PERMISSION.ALLOW_RETURN_MONTHLY_PAYMENT_NOTE_CONFIRM_REQ,
		PERMISSION.ALLOW_REJECT_MONTHLY_PAYMENT_NOTE_CONFIRM_REQ,
		PERMISSION.ALLOW_ALLOCATE_MONTHLY_PAYMENT_NOTE_CONFIRM_REQ,
	],

	// SUB: WI NOTE CONFIRM OVERALL
	WI_NOTE_CONFIRM_OVERALL: [
		SECTION.WI_NOTE_OVERALL,
		PERMISSION.READ_WI_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_CREATE_WI_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_EDIT_WI_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_ACCEPT_WI_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_RETURN_WI_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_REJECT_WI_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_ALLOCATE_WI_NOTE_CONFIRM_OVERALL_REQ,
	],

	// SUB: HC NOTE CONFIRM OVERALL
	HC_NOTE_CONFIRM_OVERALL: [
		SECTION.HC_NOTE_OVERALL,
		PERMISSION.READ_HC_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_CREATE_HC_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_EDIT_HC_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_ACCEPT_HC_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_RETURN_HC_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_REJECT_HC_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_ALLOCATE_HC_NOTE_CONFIRM_OVERALL_REQ,
	],

	// -----------------------------------------------------
	// MAIN: BRANCH NOTE OVERALL
	// -----------------------------------------------------
	BRANCH_NOTE_OVERALL: [
		SECTION.BRANCH_NOTE_OVERALL,
		PERMISSION.READ_BRANCH_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_CREATE_BRANCH_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_EDIT_BRANCH_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_ACCEPT_BRANCH_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_RETURN_BRANCH_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_REJECT_BRANCH_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_ALLOCATE_BRANCH_NOTE_OVERALL_REQ,
	],

	BRANCH_NOTE_RECEIVE: [
		SECTION.BRANCH_NOTE_RECEIVE,
		PERMISSION.READ_BRANCH_NOTE_RECEIVE,
		PERMISSION.ALLOW_CREATE_BRANCH_NOTE_RECEIVE,
		PERMISSION.ALLOW_EDIT_BRANCH_NOTE_RECEIVE,
		PERMISSION.ALLOW_ACCEPT_BRANCH_NOTE_RECEIVE,
		PERMISSION.ALLOW_RETURN_BRANCH_NOTE_RECEIVE,
		PERMISSION.ALLOW_REJECT_BRANCH_NOTE_RECEIVE,
		PERMISSION.ALLOW_ALLOCATE_BRANCH_NOTE_RECEIVE,
	],

	BRANCH_NOTE_RESULT: [
		SECTION.BRANCH_NOTE_RESULT,
		PERMISSION.READ_BRANCH_NOTE_RESULT,
		PERMISSION.ALLOW_CREATE_BRANCH_NOTE_RESULT,
		PERMISSION.ALLOW_EDIT_BRANCH_NOTE_RESULT,
		PERMISSION.ALLOW_ACCEPT_BRANCH_NOTE_RESULT,
		PERMISSION.ALLOW_RETURN_BRANCH_NOTE_RESULT,
	],

	// -----------------------------------------------------
	// MAIN: Re-Survival Inspection
	// -----------------------------------------------------
	RE_SURVIVAL_INSPECTION: [
		PERMISSION.READ_RE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_CREATE_RE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_EDIT_RE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_DELETE_RE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_SUBMIT_RE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_RETURN_RE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_REJECT_RE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_ACCEPT_RE_SVV_INSPECT_REQ,

		PERMISSION.READ_RE_SVV_INSPECT_RESULT,
	],
	// -----------------------------------------------------
	// MAIN: Benefit Non Occupate
	// -----------------------------------------------------
	BENEFIT_NON_OCCUPATION: [
		SECTION.BENEFIT_NON_OCCUPATION_VICTIM,
		PERMISSION.READ_BNO_VICTIM_REQ,
		PERMISSION.ALLOW_CREATE_BNO_VICTIM_REQ,
		PERMISSION.ALLOW_ACCEPT_BNO_VICTIM_REQ,
		PERMISSION.ALLOW_RETURN_BNO_VICTIM_REQ,
		PERMISSION.ALLOW_REJECT_BNO_VICTIM_REQ,
		PERMISSION.ALLOW_EDIT_BNO_VICTIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_BNO_VICTIM_REQ,

		SECTION.BENEFIT_NON_OCCUPATION_MEDICAL,
		PERMISSION.READ_BNO_MEDICAL_REQ,
		PERMISSION.ALLOW_CREATE_BNO_MEDICAL_REQ,
		PERMISSION.ALLOW_ACCEPT_BNO_MEDICAL_REQ,
		PERMISSION.ALLOW_RETURN_BNO_MEDICAL_REQ,
		PERMISSION.ALLOW_REJECT_BNO_MEDICAL_REQ,
		PERMISSION.ALLOW_EDIT_BNO_MEDICAL_REQ,
		PERMISSION.ALLOW_ALLOCATE_BNO_MEDICAL_REQ,

		SECTION.BENEFIT_NON_OCCUPATION_NO_REFUND,
		PERMISSION.READ_BNO_NO_REFUND_REQ,
		PERMISSION.ALLOW_CREATE_BNO_NO_REFUND_REQ,
		PERMISSION.ALLOW_ACCEPT_BNO_NO_REFUND_REQ,
		PERMISSION.ALLOW_RETURN_BNO_NO_REFUND_REQ,
		PERMISSION.ALLOW_REJECT_BNO_NO_REFUND_REQ,
		PERMISSION.ALLOW_EDIT_BNO_NO_REFUND_REQ,
		PERMISSION.ALLOW_ALLOCATE_BNO_NO_REFUND_REQ,
	],
	// -----------------------------------------------------
	// MAIN: Shipping Benefit
	// -----------------------------------------------------
	BENEFIT_SHIPPING: [
		SECTION.BENEFIT_SHIPPING_FEE,
		PERMISSION.READ_SHIPPING_FEE_REQ,
		PERMISSION.ALLOW_CREATE_SHIPPING_FEE_REQ,
		PERMISSION.ALLOW_ACCEPT_SHIPPING_FEE_REQ,
		PERMISSION.ALLOW_RETURN_SHIPPING_FEE_REQ,
		PERMISSION.ALLOW_REJECT_SHIPPING_FEE_REQ,
		PERMISSION.ALLOW_EDIT_SHIPPING_FEE_REQ,
		PERMISSION.ALLOW_ALLOCATE_SHIPPING_FEE_REQ,

		SECTION.BENEFIT_SHIPPING,
		PERMISSION.READ_SHIPPING_REQ,
		PERMISSION.ALLOW_CREATE_SHIPPING_REQ,
		PERMISSION.ALLOW_ACCEPT_SHIPPING_REQ,
		PERMISSION.ALLOW_RETURN_SHIPPING_REQ,
		PERMISSION.ALLOW_REJECT_SHIPPING_REQ,
		PERMISSION.ALLOW_EDIT_SHIPPING_REQ,
		PERMISSION.ALLOW_ALLOCATE_SHIPPING_REQ,

		SECTION.BENEFIT_SHIPPING_DECISION,
		PERMISSION.READ_SHIPPING_DECISION_REQ,
		PERMISSION.ALLOW_CREATE_SHIPPING_DECISION_REQ,
		PERMISSION.ALLOW_ACCEPT_SHIPPING_DECISION_REQ,
		PERMISSION.ALLOW_RETURN_SHIPPING_DECISION_REQ,
		PERMISSION.ALLOW_REJECT_SHIPPING_DECISION_REQ,
		PERMISSION.ALLOW_EDIT_SHIPPING_DECISION_REQ,
		PERMISSION.ALLOW_ALLOCATE_SHIPPING_DECISION_REQ,
	],
	// -----------------------------------------------------
	// MAIN: Work Activity
	// -----------------------------------------------------
	WORK_ACTIVITY_REQUEST: [
		SECTION.WORK_ACTIVITY_REQUEST,
		PERMISSION.READ_WORK_ACTIVITY_REQ,
		PERMISSION.ALLOW_CREATE_WORK_ACTIVITY_REQ,
		PERMISSION.ALLOW_ACCEPT_WORK_ACTIVITY_REQ,
		PERMISSION.ALLOW_RETURN_WORK_ACTIVITY_REQ,
		PERMISSION.ALLOW_REJECT_WORK_ACTIVITY_REQ,
		PERMISSION.ALLOW_EDIT_WORK_ACTIVITY_REQ,
		PERMISSION.ALLOW_ALLOCATE_WORK_ACTIVITY_REQ,
		PERMISSION.ALLOW_DOWNLOAD_WORK_ACTIVITY_REQ,
	],
	// -----------------------------------------------------
	// MAIN: Health Care Benefit
	// -----------------------------------------------------
	BENEFIT_HEALTH_CARE: [
		SECTION.BENEFIT_HEALTH_CARE_RECEIVER,
		PERMISSION.READ_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_CREATE_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_ACCEPT_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_RETURN_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_REJECT_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_EDIT_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_ALLOCATE_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_HQ_EDIT_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_EMC_CONTRACT_HOSPITAL,

		SECTION.BENEFIT_HEALTH_CARE_TRANSFER_DOC,
		PERMISSION.READ_HEALTH_CARE_TRANSFER_REQ,
		PERMISSION.ALLOW_CREATE_HEALTH_CARE_TRANSFER_REQ,
		PERMISSION.ALLOW_ACCEPT_HEALTH_CARE_TRANSFER_REQ,
		PERMISSION.ALLOW_RETURN_HEALTH_CARE_TRANSFER_REQ,
		PERMISSION.ALLOW_REJECT_HEALTH_CARE_TRANSFER_REQ,
		PERMISSION.ALLOW_EDIT_HEALTH_CARE_TRANSFER_REQ,
		PERMISSION.ALLOW_ALLOCATE_HEALTH_CARE_TRANSFER_REQ,

		SECTION.BENEFIT_HEALTH_CARE_RECEIVED,
		PERMISSION.READ_HEALTH_CARE_RECEIVED_REQ,
		PERMISSION.ALLOW_CREATE_HEALTH_CARE_RECEIVED_REQ,
		PERMISSION.ALLOW_ACCEPT_HEALTH_CARE_RECEIVED_REQ,
		PERMISSION.ALLOW_RETURN_HEALTH_CARE_RECEIVED_REQ,
		PERMISSION.ALLOW_REJECT_HEALTH_CARE_RECEIVED_REQ,
		PERMISSION.ALLOW_EDIT_HEALTH_CARE_RECEIVED_REQ,
		PERMISSION.ALLOW_ALLOCATE_HEALTH_CARE_RECEIVED_REQ,
	],
	// -----------------------------------------------------
	// MAIN: HC
	// -----------------------------------------------------
	CLAIM_REQUEST_HC_DOC: [
		PERMISSION.READ_EMERGENCY_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_EMERGENCY_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_EMERGENCY_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_EMERGENCY_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_EMERGENCY_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_EMERGENCY_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_EMERGENCY_DOC_CLAIM_REQ,

		PERMISSION.READ_SICK_LEAVE_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_SICK_LEAVE_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_SICK_LEAVE_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_SICK_LEAVE_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_SICK_LEAVE_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_SICK_LEAVE_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_SICK_LEAVE_DOC_CLAIM_REQ,
	],

	// SUB : HC Emergency Claim Request
	HC_CLAIM_REQUEST: [
		PERMISSION.READ_EMERGENCY_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_EMERGENCY_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_EMERGENCY_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_EMERGENCY_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_EMERGENCY_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_EMERGENCY_CLAIM_REQ,

		PERMISSION.READ_MATERNITY_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_MATERNITY_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_MATERNITY_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_MATERNITY_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_MATERNITY_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_MATERNITY_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_MATERNITY_CLAIM_REQ,
		PERMISSION.ALLOW_HQ_EDIT_MATERNITY_CLAIM_REQ,


		PERMISSION.READ_SICK_LEAVE_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_SICK_LEAVE_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_SICK_LEAVE_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_SICK_LEAVE_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_SICK_LEAVE_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_SICK_LEAVE_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_SICK_LEAVE_CLAIM_REQ,

		PERMISSION.READ_FUNERAL_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_FUNERAL_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_FUNERAL_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_FUNERAL_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_FUNERAL_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_FUNERAL_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_FUNERAL_CLAIM_REQ,
		PERMISSION.ALLOW_HQ_EDIT_FUNERAL_CLAIM_REQ
	],
	// -----------------------------------------------------
	// MAIN: Benefit Table
	// -----------------------------------------------------
	BENEFIT_TABLE: [
		SECTION.BENEFIT_TABLE,
		PERMISSION.READ_BEN_TABLE_REQ,
		PERMISSION.ALLOW_CREATE_BEN_TABLE_REQ,
		PERMISSION.ALLOW_ACCEPT_BEN_TABLE_REQ,
		PERMISSION.ALLOW_RETURN_BEN_TABLE_REQ,
		PERMISSION.ALLOW_REJECT_BEN_TABLE_REQ,
		PERMISSION.ALLOW_EDIT_BEN_TABLE_REQ,
		PERMISSION.ALLOW_ALLOCATE_BEN_TABLE_REQ,
	],

	// -----------------------------------------------------
	// MAIN: Health Care Benefit Note
	// -----------------------------------------------------
	HC_BENEFIT_NOTE: [
		PERMISSION.READ_HC_BEN_NOTE,
		PERMISSION.ALLOW_PRINT_HC_BEN_NOTE,
		PERMISSION.ALLOW_CREATE_HC_BEN_NOTE,
		PERMISSION.ALLOW_ACCEPT_HC_BEN_NOTE,
		PERMISSION.ALLOW_REJECT_HC_BEN_NOTE,
		PERMISSION.ALLOW_APPROVE_HC_BEN_NOTE,

		PERMISSION.READ_DAILY_HC_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_CREATE_DAILY_HC_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_EDIT_DAILY_HC_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_ACCEPT_DAILY_HC_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_RETURN_DAILY_HC_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_REJECT_DAILY_HC_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_ALLOCATE_DAILY_HC_NOTE_OVERALL_REQ,

		PERMISSION.READ_HC_BEN_APP,
		PERMISSION.ALLOW_CREATE_HC_BEN_APP,
		PERMISSION.ALLOW_APPROVE_HC_BEN_APP,
		PERMISSION.ALLOW_REJECT_HC_BEN_APP,
		PERMISSION.ALLOW_PRINT_HC_BEN_APP,

		PERMISSION.READ_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_CREATE_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_EDIT_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_ACCEPT_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_APPROVE_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_RETURN_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_REJECT_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_ALLOCATE_HC_NOTE_ADJUST_PAYMENT_REQ,
	],

	HC_NOTE_ADJUSTMENT: [
		PERMISSION.READ_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_CREATE_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_EDIT_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_ACCEPT_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_APPROVE_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_RETURN_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_REJECT_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_ALLOCATE_HC_NOTE_ADJUST_PAYMENT_REQ,
	],

	PROVINCE_BRANCH_NOTE: [
		PERMISSION.READ_BRANCH_HC_BEN_NOTE,
		PERMISSION.ALLOW_CREATE_BRANCH_HC_BEN_NOTE,
		PERMISSION.ALLOW_ACCEPT_BRANCH_HC_BEN_NOTE,
		PERMISSION.ALLOW_REJECT_BRANCH_HC_BEN_NOTE,
		PERMISSION.ALLOW_DEP_BRANCH_APPROVE_HC_BEN_NOTE,
		PERMISSION.ALLOW_BM_APPROVE_HC_BEN_NOTE
	],

	// -----------------------------------------------------
	// MAIN: SYSTEM TRACKING
	// -----------------------------------------------------
	SYSTEM_TRACKING: [
		SECTION.SYSTEM_TRACKING,
		PERMISSION.READ_TRACKING,
	],

	// -----------------------------------------------------
	// MAIN: ROLE TRANSFER
	// -----------------------------------------------------
	ROLE_TRANSFER: [
		SECTION.ROLE_TRANSFER,
		PERMISSION.READ_ROLE_TRANSFER,
		PERMISSION.ALLOW_CREATE_ROLE_TRANSFER,
		PERMISSION.ALLOW_DISABLE_ROLE_TRANSFER,
	],

	// -----------------------------------------------------
	// MAIN: USERS
	// -----------------------------------------------------
	NSSF_USER: [
		SECTION.NSSF_USER,
		PERMISSION.READ_NSSF_USER,
		PERMISSION.ALLOW_CREATE_NSSF_USER,
		PERMISSION.ALLOW_EDIT_NSSF_USER,
		PERMISSION.ALLOW_DISABLE_NSSF_USER,
	],
	// -----------------------------------------------------
	// MAIN: SETTING
	// -----------------------------------------------------
	SETTING: [
		SECTION.SETTING,
		PERMISSION.READ_SETTING,
		PERMISSION.ALLOW_CREATE_SETTING,
		PERMISSION.ALLOW_EDIT_SETTING,
		PERMISSION.ALLOW_DISABLE_SETTING,
	],
	// -----------------------------------------------------
	// MAIN: REPORT
	// -----------------------------------------------------
	ALL_REPORT: [
		PERMISSION.READ_WI_CLAIM_REQ_REPORT,
		PERMISSION.READ_WI_CLAIM_AMOUNT_REPORT,
		PERMISSION.READ_HC_CLAIM_REQ_REPORT,
		PERMISSION.READ_HC_CLAIM_REQ_REPORT,
	],
	REPORT_CLIAM_WI: [
		PERMISSION.READ_WI_CLAIM_REQ_REPORT,
	],
	REPORT_OFFICER_WI: [
		PERMISSION.READ_WI_CLAIM_AMOUNT_REPORT,

	],
	REPORT_CLIAM_HC: [
		PERMISSION.READ_HC_CLAIM_REQ_REPORT,
	],
	REPORT_OFFICER_HC: [
		PERMISSION.READ_HC_CLAIM_REQ_REPORT,
	],
};

export const EXTENDED_ROUTE_PMS = {
	// -----------------------------------------------------
	// MAIN: DASHBOARD
	// -----------------------------------------------------
	DASHBOARD: [PERMISSION.READ_DASHBOARD],

	// -----------------------------------------------------
	// MAIN: BENEFIT_DOC_CLAIM_REQ
	// -----------------------------------------------------
	BENEFIT_DOC_CLAIM_REQ: [
		SECTION.BENEFIT_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_BENEFIT_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_BENEFIT_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_BENEFIT_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_BENEFIT_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_BENEFIT_DOC_CLAIM_REQ,
	],

	// -----------------------------------------------------
	// MAIN: inspection request
	// -----------------------------------------------------
	INSPECTION_REQUEST: [
		SECTION.INSPECTION_REQUEST,
		PERMISSION.READ_INSPECT_REQ,
		PERMISSION.ALLOW_CREATE_INSPECT_REQ,
		PERMISSION.ALLOW_EDIT_INSPECT_REQ,
		PERMISSION.ALLOW_DELETE_INSPECT_REQ,
		PERMISSION.ALLOW_SUBMIT_INSPECT_REQ,
		PERMISSION.ALLOW_ACCEPT_INSPECT_REQ,
		PERMISSION.ALLOW_REJECT_INSPECT_REQ,
		PERMISSION.ALLOW_RETURN_INSPECT_REQ,
		PERMISSION.ALLOW_ALLOCATE_INSPECT_REQ,
	],
	INSPECTION_RESULT: [
		SECTION.INSPECTION_RESULT,
		PERMISSION.READ_INSPECT_RESULT,
	],
	// -----------------------------------------------------
	// MAIN: PRIMARY INFO
	// -----------------------------------------------------
	PRIMARY_WI_REGISTRATION: [PERMISSION.ALLOW_CREATE_WI_REQ],
	PRIMARY_WI_VALIDATION: [
		PERMISSION.READ_WI_REQ,
		PERMISSION.ALLOW_ACCEPT_WI_REQ,
		PERMISSION.ALLOW_RETURN_WI_REQ,
		PERMISSION.ALLOW_REJECT_WI_REQ,
		PERMISSION.ALLOW_EDIT_WI_REQ,
		PERMISSION.ALLOW_ALLOCATE_WI_REQ,
	],
	MERGE_SEPARATE_VICTIM: [PERMISSION.ALLOW_MERGE_SEPARATE_WI_VICTIM],

	// -----------------------------------------------------
	//  TEMP_WI_VICTIM
	// -----------------------------------------------------
	TEMP_WI_VICTIM: [
		PERMISSION.READ_TEMP_WI_VICTIM,
		PERMISSION.ALLOW_CREATE_TEMP_WI_VICTIM,
		PERMISSION.ALLOW_EDIT_TEMP_WI_VICTIM,
		PERMISSION.ALLOW_TRANSFER_TEMP_WI_VICTIM,
		PERMISSION.ALLOW_COMPLETE_TEMP_WI_VICTIM,
	],

	// -----------------------------------------------------
	// MAIN: RETREATMENT
	// -----------------------------------------------------
	RETREATMENT_REQUEST: [
		PERMISSION.READ_RETREAT_REQ,
		PERMISSION.ALLOW_CREATE_RETREAT_REQ,
		PERMISSION.ALLOW_ACCEPT_RETREAT_REQ,
		PERMISSION.ALLOW_RETURN_RETREAT_REQ,
		PERMISSION.ALLOW_REJECT_RETREAT_REQ,
		PERMISSION.ALLOW_EDIT_RETREAT_REQ,
		PERMISSION.ALLOW_ALLOCATE_RETREAT_REQ,
	],
	// -----------------------------------------------------
	// MAIN: CLAIM REPORT
	// -----------------------------------------------------
	CLAIM_TEMP_REQUEST: [
		PERMISSION.READ_CLAIM_TEMP_REQ,
		PERMISSION.ALLOW_CREATE_CLAIM_TEMP_REQ,
		PERMISSION.ALLOW_ACCEPT_CLAIM_TEMP_REQ,
		PERMISSION.ALLOW_RETURN_CLAIM_TEMP_REQ,
		PERMISSION.ALLOW_REJECT_CLAIM_TEMP_REQ,
		PERMISSION.ALLOW_EDIT_CLAIM_TEMP_REQ,
		PERMISSION.ALLOW_ALLOCATE_CLAIM_TEMP_REQ,
	],
	CLAIM_REQUEST: [
		PERMISSION.READ_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_CLAIM_REQ,
		PERMISSION.ALLOW_TRANSFER_TO_DOCTOR,
		PERMISSION.ALLOW_TRANSFER_TO_CALCULATOR,
	],
	// -----------------------------------------------------
	// MAIN: inspection request
	// -----------------------------------------------------
	SVV_INSPECTION_REQUEST: [
		//SECTION.SVV_INSPECTION_REQUEST,
		PERMISSION.READ_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_CREATE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_EDIT_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_DELETE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_SUBMIT_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_ACCEPT_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_REJECT_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_RETURN_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_ALLOCATE_SVV_INSPECT_REQ,
	],
	SVV_INSPECTION_RESULT: [
		//SECTION.SVV_INSPECTION_RESULT,
		PERMISSION.READ_SVV_INSPECT_RESULT,
	],
	// -----------------------------------------------------
	// MAIN: DAILY INCOME RECORD
	// -----------------------------------------------------
	DAILY_INCOME_RECORD: [
		PERMISSION.READ_DAILY_INCOME_REC,
		PERMISSION.ALLOW_CREATE_DAILY_INCOME_REC,
	],

	// -----------------------------------------------------
	// MAIN: PERMANENT REQUEST NOTE
	// -----------------------------------------------------
	PERMANENT_REQUEST_NOTE: [
		PERMISSION.READ_PERMANENT_REQUEST_NOTE,
		PERMISSION.ALLOW_CREATE_PERMANENT_REQUEST_NOTE,
		PERMISSION.ALLOW_ACCEPT_PERMANENT_REQUEST_NOTE,
		PERMISSION.ALLOW_RETURN_PERMANENT_REQUEST_NOTE,
		PERMISSION.ALLOW_REJECT_PERMANENT_REQUEST_NOTE,
		PERMISSION.ALLOW_EDIT_PERMANENT_REQUEST_NOTE,
		PERMISSION.ALLOW_ALLOCATE_PERMANENT_REQUEST_NOTE,
	],

	// -----------------------------------------------------
	// MAIN: PERMANENT REQUEST VALUATION
	// -----------------------------------------------------
	PERMANENT_REQUEST_VALUATION: [
		PERMISSION.READ_PERMANENT_REQUEST_VALUATION,
		PERMISSION.ALLOW_CREATE_PERMANENT_REQUEST_VALUATION,
		PERMISSION.ALLOW_ACCEPT_PERMANENT_REQUEST_VALUATION,
		PERMISSION.ALLOW_RETURN_PERMANENT_REQUEST_VALUATION,
		PERMISSION.ALLOW_REJECT_PERMANENT_REQUEST_VALUATION,
		PERMISSION.ALLOW_EDIT_PERMANENT_REQUEST_VALUATION,
		PERMISSION.ALLOW_ALLOCATE_PERMANENT_REQUEST_VALUATION,
	],

	// -----------------------------------------------------
	// MAIN: DOCTOR DOCUMENT REQUEST
	// -----------------------------------------------------
	DOCTOR_DOCUMENT_REQUEST: [
		PERMISSION.READ_DOCTOR_DOC_REQ,
		PERMISSION.ALLOW_CREATE_DOCTOR_DOC_REQ,
		PERMISSION.ALLOW_EDIT_DOCTOR_DOC_REQ,
		PERMISSION.ALLOW_DELETE_DOCTOR_DOC_REQ,
	],

	// -----------------------------------------------------
	// MAIN: CLAIM REPORT
	// -----------------------------------------------------
	MEDICAL_CLAIM_REQUEST_HC: [
		PERMISSION.READ_MEDICAL_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_MEDICAL_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_MEDICAL_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_MEDICAL_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_MEDICAL_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_MEDICAL_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_MEDICAL_DOC_CLAIM_REQ,
	],
	TEMPORARY_CLAIM_REQUEST_HC: [
		PERMISSION.READ_TEMP_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_TEMP_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_TEMP_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_TEMP_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_TEMP_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_TEMP_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_TEMP_DOC_CLAIM_REQ,
	],

	MEDICAL_CLAIM_REQUEST: [
		PERMISSION.READ_MEDICAL_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_MEDICAL_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_MEDICAL_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_MEDICAL_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_MEDICAL_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_MEDICAL_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_MEDICAL_CLAIM_REQ,
	],
	TEMPORARY_CLAIM_REQUEST: [
		PERMISSION.READ_TEMP_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_TEMP_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_TEMP_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_TEMP_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_TEMP_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_TEMP_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_TEMP_CLAIM_REQ,
	],
	PERMANENT_CLAIM_REQUEST: [
		PERMISSION.READ_PERM_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_PERM_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_PERM_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_PERM_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_PERM_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_PERM_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_PERM_CLAIM_REQ,
	],
	ALLOWANCE_CLAIM_REQUEST: [
		PERMISSION.READ_ALLOW_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_ALLOW_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_ALLOW_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_ALLOW_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_ALLOW_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_ALLOW_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_ALLOW_CLAIM_REQ,
	],
	SURVIVAL_CLAIM_REQUEST: [
		PERMISSION.READ_SURVIVAL_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_SURVIVAL_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_SURVIVAL_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_SURVIVAL_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_SURVIVAL_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_SURVIVAL_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_SURVIVAL_CLAIM_REQ,
	],
	CALCULATE_CLAIM_REQUEST: [
		PERMISSION.READ_CALCULATE_REQ,
		PERMISSION.ALLOW_CREATE_CALCULATE_REQ,
		PERMISSION.ALLOW_ACCEPT_CALCULATE_REQ,
		PERMISSION.ALLOW_RETURN_CALCULATE_REQ,
		PERMISSION.ALLOW_REJECT_CALCULATE_REQ,
		PERMISSION.ALLOW_EDIT_CALCULATE_REQ,
		PERMISSION.ALLOW_ALLOCATE_CALCULATE_REQ,
	],
	// -----------------------------------------------------
	// MAIN: PRINT INFO
	// -----------------------------------------------------
	PRINT_INFO: [
		PERMISSION.READ_PRINT_INFO_REQ,
		PERMISSION.ALLOW_CREATE_PRINT_INFO_REQ,
		PERMISSION.ALLOW_ACCEPT_PRINT_INFO_REQ,
		PERMISSION.ALLOW_RETURN_PRINT_INFO_REQ,
		PERMISSION.ALLOW_REJECT_PRINT_INFO_REQ,
		PERMISSION.ALLOW_EDIT_PRINT_INFO_REQ,
		PERMISSION.ALLOW_ALLOCATE_PRINT_INFO_REQ,
	],

	REQUEST_INFO: [
		PERMISSION.READ_BNV_REQ,
		PERMISSION.ALLOW_CREATE_BNV_REQ,
		PERMISSION.ALLOW_EDIT_BNV_REQ,
		PERMISSION.ALLOW_ACCEPT_BNV_REQ,
		PERMISSION.ALLOW_RETURN_BNV_REQ,
		PERMISSION.ALLOW_REJECT_BNV_REQ,
		PERMISSION.ALLOW_ALLOCATE_BNV_REQ,
		// PERMISSION.ALLOW_APPROVE_BNV_REQ,
		// PERMISSION.READ_BNV_ASSIGN,
	],

	// -----------------------------------------------------
	// MAIN: Benefit Approval Print
	// -----------------------------------------------------
	BENEFIT_APPROVAL_PRINT: [
		PERMISSION.READ_BENEFIT_CONFIRM_REQ,
		PERMISSION.ALLOW_APPROVE_BENEFIT_APPROVAL_REQ,
	],

	BENEFIT_APPROVAL_CONFIRM: [
		PERMISSION.READ_BNC_REQ,
		PERMISSION.ALLOW_CREATE_BNC_REQ,
		PERMISSION.ALLOW_EDIT_BNC_REQ,
		PERMISSION.ALLOW_ACCEPT_BNC_REQ,
		PERMISSION.ALLOW_RETURN_BNC_REQ,
		PERMISSION.ALLOW_REJECT_BNC_REQ,
		PERMISSION.ALLOW_ALLOCATE_BNC_REQ,
		// PERMISSION.ALLOW_APPROVE_BNC_REQ,
		// PERMISSION.READ_BNC_ASSIGN,
	],
	BENEFIT_APPROVAL_RECEIVER: [
		PERMISSION.READ_BENEFIT_CONFIRM_RECEIVER_REQ,
		PERMISSION.ALLOW_CREATE_BENEFIT_CONFIRM_RECEIVER_REQ,
		PERMISSION.ALLOW_ACCEPT_BENEFIT_CONFIRM_RECEIVER_REQ,
		PERMISSION.ALLOW_RETURN_BENEFIT_CONFIRM_RECEIVER_REQ,
		PERMISSION.ALLOW_REJECT_BENEFIT_CONFIRM_RECEIVER_REQ,
		PERMISSION.ALLOW_EDIT_BENEFIT_CONFIRM_RECEIVER_REQ,
		PERMISSION.ALLOW_ALLOCATE_BENEFIT_CONFIRM_RECEIVER_REQ,
	],
	BENEFIT_APPROVAL_YEARLY_REPORT: [
		PERMISSION.READ_BENEFIT_CONFIRM_YEARLY_REPORT_REQ,
		PERMISSION.ALLOW_CREATE_BENEFIT_CONFIRM_YEARLY_REPORT_REQ,
		PERMISSION.ALLOW_ACCEPT_BENEFIT_CONFIRM_YEARLY_REPORT_REQ,
		PERMISSION.ALLOW_RETURN_BENEFIT_CONFIRM_YEARLY_REPORT_REQ,
		PERMISSION.ALLOW_REJECT_BENEFIT_CONFIRM_YEARLY_REPORT_REQ,
		PERMISSION.ALLOW_EDIT_BENEFIT_CONFIRM_YEARLY_REPORT_REQ,
		PERMISSION.ALLOW_ALLOCATE_BENEFIT_CONFIRM_YEARLY_REPORT_REQ,
	],

	// -----------------------------------------------------
	// MAIN: Monthly Payment
	// -----------------------------------------------------

	// SUB: PERMANENT MONTHLY PAYMENT
	PERMANENT_MONTHLY_PAYMENT: [
		PERMISSION.READ_PERM_MPP_REQ,
		PERMISSION.ALLOW_CREATE_PERM_MPP_REQ,
		PERMISSION.ALLOW_EDIT_PERM_MPP_REQ,
		PERMISSION.ALLOW_ACCEPT_PERM_MPP_REQ,
		PERMISSION.ALLOW_RETURN_PERM_MPP_REQ,
		PERMISSION.ALLOW_REJECT_PERM_MPP_REQ,
		PERMISSION.ALLOW_ALLOCATE_PERM_MPP_REQ,
		PERMISSION.ALLOW_APPROVED_PERM_MPP_REQ,
	],

	// SUB: PERMANENT INFLATION
	PERMANENT_INFLATION: [
		PERMISSION.READ_PERM_INFLATION_REQ,
		PERMISSION.ALLOW_CREATE_PERM_INFLATION_REQ,
		PERMISSION.ALLOW_EDIT_PERM_INFLATION_REQ,
		PERMISSION.ALLOW_ACCEPT_PERM_INFLATION_REQ,
		PERMISSION.ALLOW_RETURN_PERM_INFLATION_REQ,
		PERMISSION.ALLOW_REJECT_PERM_INFLATION_REQ,
		PERMISSION.ALLOW_ALLOCATE_PERM_INFLATION_REQ,
	],

	// SUB: PERMANENT REEVALUATE
	PERMANENT_REEVALUATE: [
		PERMISSION.READ_PERM_REEVALUATE_REQ,
		PERMISSION.ALLOW_CREATE_PERM_REEVALUATE_REQ,
	],

	// SUB: PERMANENT PAYMENT DEDUCT
	PERMANENT_PAYMENT_DEDUCT: [
		PERMISSION.READ_PERM_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_CREATE_PERM_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_EDIT_PERM_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_ACCEPT_PERM_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_RETURN_PERM_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_REJECT_PERM_PAYMENT_DEDUCT_REQ,
	],

	// SUB: SURVIVAL MONTHLY PAYMENT
	SURVIVAL_MONTHLY_PAYMENT: [
		PERMISSION.READ_SURVIVAL_MPP_REQ,
		PERMISSION.ALLOW_CREATE_SURVIVAL_MPP_REQ,
		PERMISSION.ALLOW_EDIT_SURVIVAL_MPP_REQ,
		PERMISSION.ALLOW_ACCEPT_SURVIVAL_MPP_REQ,
		PERMISSION.ALLOW_RETURN_SURVIVAL_MPP_REQ,
		PERMISSION.ALLOW_REJECT_SURVIVAL_MPP_REQ,
	],

	// SUB: SURVIVAL REEVALUATE
	SURVIVAL_REEVALUATE: [
		PERMISSION.READ_SURVIVAL_REEVALUATE_REQ,
		PERMISSION.ALLOW_CREATE_SURVIVAL_REEVALUATE_REQ,
	],

	// SUB: SURVIVAL PAYMENT DEDUCT
	SURVIVAL_PAYMENT_DEDUCT: [
		PERMISSION.READ_SURVIVAL_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_CREATE_SURVIVAL_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_EDIT_SURVIVAL_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_ACCEPT_SURVIVAL_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_RETURN_SURVIVAL_PAYMENT_DEDUCT_REQ,
		PERMISSION.ALLOW_REJECT_SURVIVAL_PAYMENT_DEDUCT_REQ,
	],

	// SUB: MONTHLY PAYMENT NOTE
	MONTHLY_PAYMENT_NOTE: [
		PERMISSION.READ_MONTHLY_PAYMENT_NOTE_REQ,
		PERMISSION.ALLOW_CREATE_MONTHLY_PAYMENT_NOTE_REQ,
		PERMISSION.ALLOW_EDIT_MONTHLY_PAYMENT_NOTE_REQ,
		PERMISSION.ALLOW_ACCEPT_MONTHLY_PAYMENT_NOTE_REQ,
		PERMISSION.ALLOW_RETURN_MONTHLY_PAYMENT_NOTE_REQ,
		PERMISSION.ALLOW_REJECT_MONTHLY_PAYMENT_NOTE_REQ,
	],

	// SUB: MONTHLY PAYMENT NOTE CONFIRM
	MONTHLY_PAYMENT_NOTE_CONFIRM: [
		PERMISSION.READ_MONTHLY_PAYMENT_NOTE_CONFIRM_REQ,
		PERMISSION.ALLOW_CREATE_MONTHLY_PAYMENT_NOTE_CONFIRM_REQ,
		PERMISSION.ALLOW_EDIT_MONTHLY_PAYMENT_NOTE_CONFIRM_REQ,
		PERMISSION.ALLOW_ACCEPT_MONTHLY_PAYMENT_NOTE_CONFIRM_REQ,
		PERMISSION.ALLOW_RETURN_MONTHLY_PAYMENT_NOTE_CONFIRM_REQ,
		PERMISSION.ALLOW_REJECT_MONTHLY_PAYMENT_NOTE_CONFIRM_REQ,
	],

	// SUB: WI NOTE CONFIRM OVERALL
	WI_NOTE_CONFIRM_OVERALL: [
		PERMISSION.READ_WI_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_CREATE_WI_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_EDIT_WI_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_ACCEPT_WI_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_RETURN_WI_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_REJECT_WI_NOTE_CONFIRM_OVERALL_REQ,
	],

	// SUB: HC NOTE CONFIRM OVERALL
	HC_NOTE_CONFIRM_OVERALL: [
		PERMISSION.READ_HC_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_CREATE_HC_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_EDIT_HC_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_ACCEPT_HC_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_RETURN_HC_NOTE_CONFIRM_OVERALL_REQ,
		PERMISSION.ALLOW_REJECT_HC_NOTE_CONFIRM_OVERALL_REQ,
	],

	// -----------------------------------------------------
	// MAIN: BRANCH NOTE OVERALL
	// -----------------------------------------------------
	BRANCH_NOTE_OVERALL: [
		PERMISSION.READ_BRANCH_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_CREATE_BRANCH_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_EDIT_BRANCH_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_ACCEPT_BRANCH_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_RETURN_BRANCH_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_REJECT_BRANCH_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_ALLOCATE_BRANCH_NOTE_OVERALL_REQ,
	],

	BRANCH_NOTE_RECEIVE: [
		PERMISSION.READ_BRANCH_NOTE_RECEIVE,
		PERMISSION.ALLOW_CREATE_BRANCH_NOTE_RECEIVE,
		PERMISSION.ALLOW_EDIT_BRANCH_NOTE_RECEIVE,
		PERMISSION.ALLOW_ACCEPT_BRANCH_NOTE_RECEIVE,
		PERMISSION.ALLOW_RETURN_BRANCH_NOTE_RECEIVE,
		PERMISSION.ALLOW_REJECT_BRANCH_NOTE_RECEIVE,
		PERMISSION.ALLOW_ALLOCATE_BRANCH_NOTE_RECEIVE,
	],

	BRANCH_NOTE_RESULT: [
		PERMISSION.READ_BRANCH_NOTE_RESULT,
		PERMISSION.ALLOW_CREATE_BRANCH_NOTE_RESULT,
		PERMISSION.ALLOW_EDIT_BRANCH_NOTE_RESULT,
		PERMISSION.ALLOW_ACCEPT_BRANCH_NOTE_RESULT,
		PERMISSION.ALLOW_RETURN_BRANCH_NOTE_RESULT
	],

	// -----------------------------------------------------
	// MAIN: Re-Survival Inspection
	// -----------------------------------------------------
	RE_SVV_REQUEST: [
		PERMISSION.READ_RE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_CREATE_RE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_EDIT_RE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_DELETE_RE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_SUBMIT_RE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_RETURN_RE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_REJECT_RE_SVV_INSPECT_REQ,
		PERMISSION.ALLOW_ACCEPT_RE_SVV_INSPECT_REQ,
	],
	RE_SVV_RESULT: [
		PERMISSION.READ_RE_SVV_INSPECT_RESULT,
	],
	// -----------------------------------------------------
	// MAIN: Benefit Non Occupate
	// -----------------------------------------------------
	BENEFIT_NON_OCCUPATION_VICTIM: [
		PERMISSION.READ_BNO_VICTIM_REQ,
		PERMISSION.ALLOW_CREATE_BNO_VICTIM_REQ,
		PERMISSION.ALLOW_ACCEPT_BNO_VICTIM_REQ,
		PERMISSION.ALLOW_RETURN_BNO_VICTIM_REQ,
		PERMISSION.ALLOW_REJECT_BNO_VICTIM_REQ,
		PERMISSION.ALLOW_EDIT_BNO_VICTIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_BNO_VICTIM_REQ,
	],
	BENEFIT_NON_OCCUPATION_MEDICAL: [
		PERMISSION.READ_BNO_MEDICAL_REQ,
		PERMISSION.ALLOW_CREATE_BNO_MEDICAL_REQ,
		PERMISSION.ALLOW_ACCEPT_BNO_MEDICAL_REQ,
		PERMISSION.ALLOW_RETURN_BNO_MEDICAL_REQ,
		PERMISSION.ALLOW_REJECT_BNO_MEDICAL_REQ,
		PERMISSION.ALLOW_EDIT_BNO_MEDICAL_REQ,
		PERMISSION.ALLOW_ALLOCATE_BNO_MEDICAL_REQ,
	],
	BENEFIT_NON_OCCUPATION_NO_REFUND: [
		PERMISSION.READ_BNO_NO_REFUND_REQ,
		PERMISSION.ALLOW_CREATE_BNO_NO_REFUND_REQ,
		PERMISSION.ALLOW_ACCEPT_BNO_NO_REFUND_REQ,
		PERMISSION.ALLOW_RETURN_BNO_NO_REFUND_REQ,
		PERMISSION.ALLOW_REJECT_BNO_NO_REFUND_REQ,
		PERMISSION.ALLOW_EDIT_BNO_NO_REFUND_REQ,
		PERMISSION.ALLOW_ALLOCATE_BNO_NO_REFUND_REQ,
	],
	// -----------------------------------------------------
	// MAIN: Shipping Benefit
	// -----------------------------------------------------
	BENEFIT_SHIPPING_FEE: [
		PERMISSION.READ_SHIPPING_FEE_REQ,
		PERMISSION.ALLOW_CREATE_SHIPPING_FEE_REQ,
		PERMISSION.ALLOW_ACCEPT_SHIPPING_FEE_REQ,
		PERMISSION.ALLOW_RETURN_SHIPPING_FEE_REQ,
		PERMISSION.ALLOW_REJECT_SHIPPING_FEE_REQ,
		PERMISSION.ALLOW_EDIT_SHIPPING_FEE_REQ,
		PERMISSION.ALLOW_ALLOCATE_SHIPPING_FEE_REQ,
	],
	BENEFIT_SHIPPING: [
		PERMISSION.READ_SHIPPING_REQ,
		PERMISSION.ALLOW_CREATE_SHIPPING_REQ,
		PERMISSION.ALLOW_ACCEPT_SHIPPING_REQ,
		PERMISSION.ALLOW_RETURN_SHIPPING_REQ,
		PERMISSION.ALLOW_REJECT_SHIPPING_REQ,
		PERMISSION.ALLOW_EDIT_SHIPPING_REQ,
		PERMISSION.ALLOW_ALLOCATE_SHIPPING_REQ,
	],
	BENEFIT_SHIPPING_DECISION: [
		PERMISSION.READ_SHIPPING_DECISION_REQ,
		PERMISSION.ALLOW_CREATE_SHIPPING_DECISION_REQ,
		PERMISSION.ALLOW_ACCEPT_SHIPPING_DECISION_REQ,
		PERMISSION.ALLOW_RETURN_SHIPPING_DECISION_REQ,
		PERMISSION.ALLOW_REJECT_SHIPPING_DECISION_REQ,
		PERMISSION.ALLOW_EDIT_SHIPPING_DECISION_REQ,
		PERMISSION.ALLOW_ALLOCATE_SHIPPING_DECISION_REQ,
	],
	// -----------------------------------------------------
	// MAIN: Work Activity
	// -----------------------------------------------------
	WORK_ACTIVITY_REQUEST: [
		PERMISSION.READ_WORK_ACTIVITY_REQ,
		PERMISSION.ALLOW_CREATE_WORK_ACTIVITY_REQ,
		PERMISSION.ALLOW_ACCEPT_WORK_ACTIVITY_REQ,
		PERMISSION.ALLOW_RETURN_WORK_ACTIVITY_REQ,
		PERMISSION.ALLOW_REJECT_WORK_ACTIVITY_REQ,
		PERMISSION.ALLOW_EDIT_WORK_ACTIVITY_REQ,
		PERMISSION.ALLOW_ALLOCATE_WORK_ACTIVITY_REQ,
		PERMISSION.ALLOW_DOWNLOAD_WORK_ACTIVITY_REQ,
	],
	// -----------------------------------------------------
	// MAIN: Health Care Benefit
	// -----------------------------------------------------
	BENEFIT_HEALTH_CARE_RECEIVER: [
		PERMISSION.READ_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_CREATE_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_ACCEPT_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_RETURN_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_REJECT_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_EDIT_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_ALLOCATE_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_HQ_EDIT_HEALTH_CARE_RECEIVER_REQ,
		PERMISSION.ALLOW_EMC_CONTRACT_HOSPITAL,
	],
	BENEFIT_HEALTH_CARE_TRANSFER_DOC: [
		PERMISSION.READ_HEALTH_CARE_TRANSFER_REQ,
		PERMISSION.ALLOW_CREATE_HEALTH_CARE_TRANSFER_REQ,
		PERMISSION.ALLOW_ACCEPT_HEALTH_CARE_TRANSFER_REQ,
		PERMISSION.ALLOW_RETURN_HEALTH_CARE_TRANSFER_REQ,
		PERMISSION.ALLOW_REJECT_HEALTH_CARE_TRANSFER_REQ,
		PERMISSION.ALLOW_EDIT_HEALTH_CARE_TRANSFER_REQ,
		PERMISSION.ALLOW_ALLOCATE_HEALTH_CARE_TRANSFER_REQ,
	],
	BENEFIT_HEALTH_CARE_RECEIVED: [
		PERMISSION.READ_HEALTH_CARE_RECEIVED_REQ,
		PERMISSION.ALLOW_CREATE_HEALTH_CARE_RECEIVED_REQ,
		PERMISSION.ALLOW_ACCEPT_HEALTH_CARE_RECEIVED_REQ,
		PERMISSION.ALLOW_RETURN_HEALTH_CARE_RECEIVED_REQ,
		PERMISSION.ALLOW_REJECT_HEALTH_CARE_RECEIVED_REQ,
		PERMISSION.ALLOW_EDIT_HEALTH_CARE_RECEIVED_REQ,
		PERMISSION.ALLOW_ALLOCATE_HEALTH_CARE_RECEIVED_REQ,
	],
	// -----------------------------------------------------
	// MAIN: HC
	// -----------------------------------------------------
	// SUB : HC Emergency Claim Request
	EMERGENCY_CLAIM_REQUEST_HC: [
		PERMISSION.READ_EMERGENCY_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_EMERGENCY_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_EMERGENCY_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_EMERGENCY_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_EMERGENCY_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_EMERGENCY_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_EMERGENCY_DOC_CLAIM_REQ,

	],
	// SUB : HC Emergency Claim Request
	HC_EMERGENCY_CLAIM_REQUEST: [
		PERMISSION.READ_EMERGENCY_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_EMERGENCY_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_EMERGENCY_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_EMERGENCY_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_EMERGENCY_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_EMERGENCY_CLAIM_REQ,
	],
	// SUB : HC Maternity Claim Request
	HC_MATERNITY_CLAIM_REQUEST: [
		PERMISSION.READ_MATERNITY_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_MATERNITY_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_MATERNITY_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_MATERNITY_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_MATERNITY_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_MATERNITY_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_MATERNITY_CLAIM_REQ,
		PERMISSION.ALLOW_HQ_EDIT_MATERNITY_CLAIM_REQ,

	],
	// SUB : HC Sick Leave Claim Request
	SICK_LEAVE_CLAIM_REQUEST_HC: [
		PERMISSION.READ_SICK_LEAVE_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_SICK_LEAVE_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_SICK_LEAVE_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_SICK_LEAVE_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_SICK_LEAVE_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_SICK_LEAVE_DOC_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_SICK_LEAVE_DOC_CLAIM_REQ,

	],
	// SUB : HC Sick Leave Claim Request
	HC_SICK_LEAVE_CLAIM_REQUEST: [
		PERMISSION.READ_SICK_LEAVE_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_SICK_LEAVE_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_SICK_LEAVE_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_SICK_LEAVE_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_SICK_LEAVE_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_SICK_LEAVE_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_SICK_LEAVE_CLAIM_REQ,

	],
	// SUB : HC Transport Claim Request
	HC_TRANSPORT_CLAIM_REQUEST: [
		PERMISSION.READ_TRANSPORT_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_TRANSPORT_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_TRANSPORT_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_TRANSPORT_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_TRANSPORT_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_TRANSPORT_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_TRANSPORT_CLAIM_REQ,
	],
	// SUB : HC Funeral Claim Request
	HC_FUNERAL_CLAIM_REQUEST: [
		PERMISSION.READ_FUNERAL_CLAIM_REQ,
		PERMISSION.ALLOW_CREATE_FUNERAL_CLAIM_REQ,
		PERMISSION.ALLOW_ACCEPT_FUNERAL_CLAIM_REQ,
		PERMISSION.ALLOW_RETURN_FUNERAL_CLAIM_REQ,
		PERMISSION.ALLOW_REJECT_FUNERAL_CLAIM_REQ,
		PERMISSION.ALLOW_EDIT_FUNERAL_CLAIM_REQ,
		PERMISSION.ALLOW_ALLOCATE_FUNERAL_CLAIM_REQ,
		PERMISSION.ALLOW_HQ_EDIT_FUNERAL_CLAIM_REQ
	],
	// SUB : HC Doctor Report
	HC_DOCTOR_REPORT: [
		PERMISSION.READ_HC_DOCTOR_REPORT,
		PERMISSION.ALLOW_CREATE_HC_DOCTOR_REPORT,
		PERMISSION.ALLOW_EDIT_HC_DOCTOR_REPORT,
		PERMISSION.ALLOW_ACCEPT_HC_DOCTOR_REPORT,
		PERMISSION.ALLOW_RETURN_HC_DOCTOR_REPORT,
		PERMISSION.ALLOW_REJECT_HC_DOCTOR_REPORT,
		PERMISSION.ALLOW_ALLOCATE_HC_DOCTOR_REPORT,
	],
	// -----------------------------------------------------
	// MAIN: Benefit Table
	// -----------------------------------------------------
	BENEFIT_TABLE: [
		PERMISSION.READ_BEN_TABLE_REQ,
		PERMISSION.ALLOW_CREATE_BEN_TABLE_REQ,
		PERMISSION.ALLOW_ACCEPT_BEN_TABLE_REQ,
		PERMISSION.ALLOW_RETURN_BEN_TABLE_REQ,
		PERMISSION.ALLOW_REJECT_BEN_TABLE_REQ,
		PERMISSION.ALLOW_EDIT_BEN_TABLE_REQ,
		PERMISSION.ALLOW_ALLOCATE_BEN_TABLE_REQ,
	],

	// -----------------------------------------------------
	// MAIN: Benefit Note
	// -----------------------------------------------------
	// SUB : HC Benefit Note
	NOTE: [
		PERMISSION.READ_HC_BEN_NOTE,
		PERMISSION.ALLOW_CREATE_HC_BEN_NOTE,
		PERMISSION.ALLOW_ACCEPT_HC_BEN_NOTE,
		PERMISSION.ALLOW_REJECT_HC_BEN_NOTE,
		PERMISSION.ALLOW_PRINT_HC_BEN_NOTE,
		PERMISSION.ALLOW_APPROVE_HC_BEN_NOTE
	],

	NOTE_ADJUSTMENT: [
		PERMISSION.READ_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_CREATE_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_EDIT_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_ACCEPT_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_APPROVE_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_RETURN_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_REJECT_HC_NOTE_ADJUST_PAYMENT_REQ,
		PERMISSION.ALLOW_ALLOCATE_HC_NOTE_ADJUST_PAYMENT_REQ,
	],

	PROVINCE_BRANCH_NOTE: [
		PERMISSION.READ_BRANCH_HC_BEN_NOTE,
		PERMISSION.ALLOW_CREATE_BRANCH_HC_BEN_NOTE,
		PERMISSION.ALLOW_ACCEPT_BRANCH_HC_BEN_NOTE,
		PERMISSION.ALLOW_REJECT_BRANCH_HC_BEN_NOTE,
		PERMISSION.ALLOW_DEP_BRANCH_APPROVE_HC_BEN_NOTE,
		PERMISSION.ALLOW_BM_APPROVE_HC_BEN_NOTE,
		PERMISSION.ALLOW_MARK_CORRECT_BRANCH_HC_BEN_NOTE,
	],

	// SUB : Daily HC Note Overall
	DAILY_HC_NOTE_OVERALL: [
		PERMISSION.READ_DAILY_HC_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_CREATE_DAILY_HC_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_ACCEPT_DAILY_HC_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_REJECT_DAILY_HC_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_EDIT_DAILY_HC_NOTE_OVERALL_REQ,
		PERMISSION.ALLOW_ALLOCATE_DAILY_HC_NOTE_OVERALL_REQ,
	],

	// SUB : HC Benefit Approval
	APPROVAL: [
		PERMISSION.READ_HC_BEN_APP,
		PERMISSION.ALLOW_CREATE_HC_BEN_APP,
		PERMISSION.ALLOW_APPROVE_HC_BEN_APP,
		PERMISSION.ALLOW_REJECT_HC_BEN_APP,
		PERMISSION.ALLOW_PRINT_HC_BEN_APP
	],

	// -----------------------------------------------------
	// MAIN: SYSTEM TRACKING
	// -----------------------------------------------------
	SYSTEM_TRACKING: [
		PERMISSION.READ_TRACKING,
	],
	// -----------------------------------------------------
	// MAIN: ROLE TRANSFER
	// -----------------------------------------------------
	ROLE_TRANSFER: [
		PERMISSION.READ_ROLE_TRANSFER,
		PERMISSION.ALLOW_CREATE_ROLE_TRANSFER,
		PERMISSION.ALLOW_DISABLE_ROLE_TRANSFER,
	],

	// -----------------------------------------------------
	// MAIN: USERS
	// -----------------------------------------------------
	NSSF_USER: [
		PERMISSION.READ_NSSF_USER,
		PERMISSION.ALLOW_CREATE_NSSF_USER,
		PERMISSION.ALLOW_EDIT_NSSF_USER,
		PERMISSION.ALLOW_DISABLE_NSSF_USER,
	],

	// -----------------------------------------------------
	// MAIN: SETTING
	// -----------------------------------------------------
	SETTING: [
		PERMISSION.READ_SETTING,
		PERMISSION.ALLOW_CREATE_SETTING,
		PERMISSION.ALLOW_EDIT_SETTING,
		PERMISSION.ALLOW_DISABLE_SETTING,
	],
	// -----------------------------------------------------
	// MAIN: REPORT
	// -----------------------------------------------------
	// ALL_REPORT: [
	//   PERMISSION.READ_WI_CLAIM_REQ_REPORT,
	//   PERMISSION.READ_WI_CLAIM_AMOUNT_REPORT,
	//   PERMISSION.READ_HC_CLAIM_REQ_REPORT,
	//   PERMISSION.READ_HC_CLAIM_REQ_REPORT,

	//   PERMISSION.READ_WI_CLAIMANT_REPORT,
	//   PERMISSION.READ_WI_CLAIM_BY_ENT_ADDR_REPORT,
	//   PERMISSION.READ_WI_CLAIM_APPROVAL_REPORT,
	//   PERMISSION.READ_WI_CLAIM_EXPANSE_REPORT,

	//   PERMISSION.READ_HC_CLAIM_REQ_REPORT,
	//   PERMISSION.READ_HC_CLAIM_AMOUNT_REPORT,
	//   PERMISSION.READ_HC_CLAIM_BY_ENT_ADDR_REPORT,
	//   PERMISSION.READ_HC_CLAIM_APPROVAL_REPORT,
	//   PERMISSION.READ_HC_CLAIM_EXPANSE_REPORT,
	// ]

	READ_WI_CLAIM_REQ_REPORT: [
		PERMISSION.READ_WI_CLAIM_REQ_REPORT
	],
	READ_WI_CLAIM_AMOUNT_REPORT: [
		PERMISSION.READ_WI_CLAIM_AMOUNT_REPORT
	],
	READ_WI_CLAIMANT_REPORT: [
		PERMISSION.READ_WI_CLAIMANT_REPORT
	],
	READ_WI_CLAIM_BY_ENT_ADDR_REPORT: [
		PERMISSION.READ_WI_CLAIM_BY_ENT_ADDR_REPORT
	],
	READ_WI_CLAIM_APPROVAL_REPORT: [
		PERMISSION.READ_WI_CLAIM_APPROVAL_REPORT
	],
	READ_WI_CLAIM_EXPANSE_REPORT: [
		PERMISSION.READ_WI_CLAIM_EXPANSE_REPORT
	],


	READ_HC_CLAIM_REQ_REPORT: [
		PERMISSION.READ_HC_CLAIM_REQ_REPORT
	],
	READ_HC_CLAIM_AMOUNT_REPORT: [
		PERMISSION.READ_HC_CLAIM_AMOUNT_REPORT
	],
	READ_HC_CLAIM_BY_ENT_ADDR_REPORT: [
		PERMISSION.READ_HC_CLAIM_BY_ENT_ADDR_REPORT
	],
	READ_HC_CLAIM_APPROVAL_REPORT: [
		PERMISSION.READ_HC_CLAIM_APPROVAL_REPORT
	],
	READ_HC_CLAIM_EXPANSE_REPORT: [
		PERMISSION.READ_HC_CLAIM_EXPANSE_REPORT
	],
};

export const ROUTE_PMS_JSON = [
	{
		name: SECTION.DASHBOARD,
		key: 'DASHBOARD',
		icon: 'dashboard',
		children: [
			{
				name: SECTION.DASHBOARD_WORK,
				path: '/dashboard',
				pms_keys: [PERMISSION.READ_DASHBOARD],
			},
		],
	},
	{
		name: SECTION.BENEFIT_DOC_CLAIM_REQ,
		key: 'BENEFIT_DOC_CLAIM_REQ',
		icon: 'contact_emergency',
		children: [
			{
				name: SECTION.BENEFIT_DOC_CLAIM_REQ_LIST,
				path: '/receive-claim-request',
				pms_keys: [
					PERMISSION.READ_BENEFIT_DOC_CLAIM_REQ,
					PERMISSION.ALLOW_CREATE_BENEFIT_DOC_CLAIM_REQ,
					PERMISSION.ALLOW_ACCEPT_BENEFIT_DOC_CLAIM_REQ,
					PERMISSION.ALLOW_RETURN_BENEFIT_DOC_CLAIM_REQ,
					PERMISSION.ALLOW_REJECT_BENEFIT_DOC_CLAIM_REQ,
					PERMISSION.ALLOW_EDIT_BENEFIT_DOC_CLAIM_REQ,
					PERMISSION.ALLOW_DELETE_BENEFIT_DOC_CLAIM_REQ
				],
			},
		],
	},
	{
		name: SECTION.PRIMARY_WI_REQUEST,
		key: 'PRIMARY_WI_REQUEST',
		icon: 'corporate_fare',
		children: [
			{
				name: SECTION.PRIMARY_WI_REGISTRATION,
				path: '/accident-request/register',
				pms_keys: EXTENDED_ROUTE_PMS.PRIMARY_WI_REGISTRATION,
			},
			{
				name: SECTION.PRIMARY_WI_VALIDATION,
				path: '/accident-request/request',
				pms_keys: EXTENDED_ROUTE_PMS.PRIMARY_WI_VALIDATION,
			},
			{
				name: SECTION.MERGE_SEPARATE_VICTIM,
				path: '/accident-request/injuryReport',
				pms_keys: EXTENDED_ROUTE_PMS.MERGE_SEPARATE_VICTIM,
			},
		],
	},
	{
		name: SECTION.INSPECTION_REQUEST_HEAD,
		key: 'INSPECTION_REQUEST',
		icon: 'corporate_fare',
		children: [
			{
				name: SECTION.INSPECTION_REQUEST,
				path: '/inspection/inspection-request',
				pms_keys: [
					PERMISSION.READ_INSPECT_REQ,
					PERMISSION.ALLOW_CREATE_INSPECT_REQ,
					PERMISSION.ALLOW_EDIT_INSPECT_REQ,
					PERMISSION.ALLOW_DELETE_INSPECT_REQ,
					PERMISSION.ALLOW_SUBMIT_INSPECT_REQ,
					PERMISSION.ALLOW_ACCEPT_INSPECT_REQ,
					PERMISSION.ALLOW_REJECT_INSPECT_REQ,
					PERMISSION.ALLOW_RETURN_INSPECT_REQ,
					PERMISSION.ALLOW_ALLOCATE_INSPECT_REQ,
				],
			},
			{
				name: SECTION.INSPECTION_RESULT,
				path: '/inspection/inspection-result',
				pms_keys: [PERMISSION.READ_INSPECT_RESULT],
			},
		],
	},
	{
		name: SECTION.TEMP_WI_VICTIM,
		key: 'TEMP_WI_VICTIM',
		icon: 'report',
		children: [
			{
				name: SECTION.TEMP_WI_VICTIM,
				path: '/temp-wi-victim',
				pms_keys: EXTENDED_ROUTE_PMS.TEMP_WI_VICTIM,
			},
		],
	},
	{
		name: SECTION.RETREATMENT_REQUEST,
		key: 'RETREATMENT_REQUEST',
		icon: 'corporate_fare',
		children: [
			{
				name: SECTION.RETREATMENT_REQUEST,
				path: '/retreatment-injury',
				pms_keys: EXTENDED_ROUTE_PMS.RETREATMENT_REQUEST,
			},
		],
	},
	{
		name: SECTION.MAIN_CLAIM_REQUEST,
		key: 'CLAIM_REQUEST',
		icon: 'corporate_fare',
		children: [
			{
				name: SECTION.CLAIM_TEMP_REQUEST,
				path: '/claim-report/temporaryclaimreport',
				pms_keys: EXTENDED_ROUTE_PMS.CLAIM_TEMP_REQUEST,
			},
			{
				name: SECTION.CLAIM_REQUEST,
				path: '/claim-report/receiveclaimreport',
				pms_keys: EXTENDED_ROUTE_PMS.CLAIM_REQUEST,
			},
		],
	},
	{
		name: SECTION.PERMANENT_REQUEST_NOTE,
		key: 'PERMANENT_REQUEST_NOTE',
		icon: 'how_to_reg',
		children: [
			{
				name: SECTION.PERMANENT_REQUEST_NOTE,
				path: '/permanent-request',
				pms_keys: EXTENDED_ROUTE_PMS.PERMANENT_REQUEST_NOTE,
			},
		],
	},
	{
		name: SECTION.PERMANENT_REQUEST_VALUATION,
		key: 'PERMANENT_REQUEST_VALUATION',
		icon: 'accessible_forward',
		children: [
			{
				name: SECTION.PERMANENT_REQUEST_VALUATION,
				path: '/perm-loss-ass-req',
				pms_keys: EXTENDED_ROUTE_PMS.PERMANENT_REQUEST_VALUATION,
			},
		],
	},
	{
		name: SECTION.DOCTOR_DOCUMENT_REQUEST,
		key: 'DOCTOR_DOCUMENT_REQUEST',
		icon: 'snippet_folder',
		children: [
			{
				name: SECTION.DOCTOR_DOCUMENT_REQUEST,
				path: '/doctor-document',
				pms_keys: EXTENDED_ROUTE_PMS.DOCTOR_DOCUMENT_REQUEST,
			},
		],
	},
	{
		name: SECTION.SVV_INSPECTION_REQUEST_HEAD,
		key: 'SVV_INSPECTION',
		icon: 'diversity_3',
		children: [
			{
				name: SECTION.SVV_INSPECTION_REQUEST,
				path: '/svv-inspection/svv-inspection-request',
				pms_keys: EXTENDED_ROUTE_PMS.SVV_INSPECTION_REQUEST,
			},
			{
				name: SECTION.SVV_INSPECTION_RESULT,
				path: '/svv-inspection/svv-inspection-result',
				pms_keys: EXTENDED_ROUTE_PMS.SVV_INSPECTION_RESULT,
			},
		],
	},
	{
		name: SECTION.DAILY_INCOME_RECORD,
		key: 'DAILY_INCOME_RECORD',
		icon: 'point_of_sale',
		children: [
			{
				name: SECTION.DAILY_INCOME_RECORD,
				path: '/victim-benifit',
				pms_keys: EXTENDED_ROUTE_PMS.DAILY_INCOME_RECORD,
			},
		],
	},
	{
		name: SECTION.MEDICAL_CLAIM_REQUEST_MAIN_HOST,
		key: 'BENEFIT_CLAIM_REQUEST_HC',
		icon: 'receipt_long',
		children: [
			{
				name: SECTION.MEDICAL_CLAIM_REQUEST_DOC,
				path: '/claim-request-hc/health-care',
				pms_keys: EXTENDED_ROUTE_PMS.MEDICAL_CLAIM_REQUEST_HC,
			},
			{
				name: SECTION.TEMPORARY_CLAIM_REQUEST_DOC,
				path: '/claim-request-hc/temporary',
				pms_keys: EXTENDED_ROUTE_PMS.TEMPORARY_CLAIM_REQUEST_HC,
			},

		],
	},
	{
		name: SECTION.MEDICAL_CLAIM_REQUEST_MAIN,
		key: 'BENEFIT_CLAIM_REQUEST',
		icon: 'receipt_long',
		children: [
			{
				name: SECTION.MEDICAL_CLAIM_REQUEST,
				path: '/claim-request/health-care',
				pms_keys: EXTENDED_ROUTE_PMS.MEDICAL_CLAIM_REQUEST,
			},
			{
				name: SECTION.TEMPORARY_CLAIM_REQUEST,
				path: '/claim-request/temporary',
				pms_keys: EXTENDED_ROUTE_PMS.TEMPORARY_CLAIM_REQUEST,
			},
			{
				name: SECTION.PERMANENT_CLAIM_REQUEST,
				path: '/claim-request/permanent',
				pms_keys: EXTENDED_ROUTE_PMS.PERMANENT_CLAIM_REQUEST,
			},
			{
				name: SECTION.ALLOWANCE_CLAIM_REQUEST,
				path: '/claim-request/allowance',
				pms_keys: EXTENDED_ROUTE_PMS.ALLOWANCE_CLAIM_REQUEST,
			},
			{
				name: SECTION.SURVIVAL_CLAIM_REQUEST,
				path: '/claim-request/survival',
				pms_keys: EXTENDED_ROUTE_PMS.SURVIVAL_CLAIM_REQUEST,
			},
			{
				name: SECTION.CALCULATE_CLAIM_REQUEST,
				path: '/claim-request/survival',
				pms_keys: EXTENDED_ROUTE_PMS.CALCULATE_CLAIM_REQUEST,
			},
		],
	},
	{
		name: SECTION.PRINT_INOF_HEAD,
		key: 'PRINT_INFO',
		icon: 'print_connect',
		children: [
			{
				name: SECTION.PRINT_INFO,
				path: '/print/print-info',
				pms_keys: EXTENDED_ROUTE_PMS.PRINT_INFO,
			},
			{
				name: SECTION.REQUEST_INFO,
				path: '/print/request-info',
				pms_keys: EXTENDED_ROUTE_PMS.REQUEST_INFO,
			},
		],
	},
	{
		name: SECTION.MAIN_BENEFIT_APPROVAL,
		key: 'BENEFIT_APPROVAL',
		icon: 'receipt_long',
		children: [
			{
				name: SECTION.BENEFIT_APPROVAL_PRINT,
				path: '/benefit-approval/benefitprint',
				pms_keys: EXTENDED_ROUTE_PMS.BENEFIT_APPROVAL_PRINT,
			},
			{
				name: SECTION.BENEFIT_APPROVAL_RECEIVER,
				path: '/benefit-approval/benefitapproval',
				pms_keys: EXTENDED_ROUTE_PMS.BENEFIT_APPROVAL_CONFIRM,
			},
			// {
			//   name: SECTION.BENEFIT_APPROVAL_YEARLY_REPORT,
			//   path: '/benefit-approval/yearlyreport',
			//   pms_keys: EXTENDED_ROUTE_PMS.BENEFIT_APPROVAL_YEARLY_REPORT,
			// },
		],
	},
	{
		name: SECTION.MAIN_PERMANENT_PAYMENT,
		key: 'PERMANENT_MONTHLY_PAYMENT',
		icon: 'receipt_long',
		children: [
			{
				name: SECTION.PERMANENT_MPP,
				path: '/monthly-pension-payment/perm-mpp',
				pms_keys: EXTENDED_ROUTE_PMS.PERMANENT_MONTHLY_PAYMENT,
			},
			{
				name: SECTION.PERMANENT_INFLATION,
				path: '/monthly-pension-payment/annual-inflat',
				pms_keys: EXTENDED_ROUTE_PMS.PERMANENT_INFLATION,
			},
			{
				name: SECTION.PERMANENT_REEVALUATE,
				path: '/monthly-pension-payment/payment-reevaluate',
				pms_keys: EXTENDED_ROUTE_PMS.PERMANENT_REEVALUATE,
			},
			{
				name: SECTION.PERMANENT_PAYMENT_DEDUCT,
				path: '/monthly-pension-payment/payment-allow-amount',
				pms_keys: EXTENDED_ROUTE_PMS.PERMANENT_PAYMENT_DEDUCT,
			},
		]
	},
	{
		name: SECTION.MAIN_SURVIVAL_PAYMENT,
		key: 'SURVIVAL_MONTHLY_PAYMENT',
		icon: 'receipt_long',
		children: [
			{
				name: SECTION.SURVIVAL_MPP,
				path: '/svv-monthly-payment/svv-payment',
				pms_keys: EXTENDED_ROUTE_PMS.SURVIVAL_MONTHLY_PAYMENT,
			},
			{
				name: SECTION.SURVIVAL_REEVALUATE,
				path: '/svv-monthly-payment/payment-reevaluate',
				pms_keys: EXTENDED_ROUTE_PMS.SURVIVAL_REEVALUATE,
			},
			{
				name: SECTION.SURVIVAL_PAYMENT_DEDUCT,
				path: '/svv-monthly-payment/payment-allow-amount',
				pms_keys: EXTENDED_ROUTE_PMS.SURVIVAL_PAYMENT_DEDUCT,
			},
		]
	},
	{
		name: SECTION.MAIN_PAYMENT_NOTE,
		key: 'MONTHLY_PAYMENT_NOTE',
		icon: 'receipt_long',
		children: [
			{
				name: SECTION.PAYMENT_NOTE,
				path: '/payment-note/ben-note',
				pms_keys: EXTENDED_ROUTE_PMS.MONTHLY_PAYMENT_NOTE,
			},
			{
				name: SECTION.PAYMENT_NOTE_CONFIRM,
				path: '/payment-note/ben-note-confirm',
				pms_keys: EXTENDED_ROUTE_PMS.MONTHLY_PAYMENT_NOTE_CONFIRM,
			}
		]
	},
	{
		name: SECTION.RE_SVV_INSPECTION_HEAD,
		key: 'RE_SURVIVAL_INSPECTION',
		icon: 'diversity_3',
		children: [
			// {
			// 	name: SECTION.RE_SVV_INSPECTION_REQUEST,
			// 	path:'/re-svv-inspection/re-svv-inspection-request',
			// 	pms_keys:EXTENDED_ROUTE_PMS.RE_SVV_REQUEST
			// },
			{
				name: SECTION.RE_SVV_INSPECTION_RESULT,
				path: '/re-svv-inspection/re-svv-inspection-result',
				pms_keys: EXTENDED_ROUTE_PMS.RE_SVV_RESULT
			}
		]
	},
	{
		name: SECTION.MAIN_BENEFIT_NON_OCCUPATION,
		key: 'BENEFIT_NON_OCCUPATION',
		icon: 'receipt_long',
		children: [
			{
				name: SECTION.BENEFIT_NON_OCCUPATION_VICTIM,
				path: '/benefit-non-occupate/nonoccupatevictims',
				pms_keys: EXTENDED_ROUTE_PMS.BENEFIT_NON_OCCUPATION_VICTIM,
			},
			{
				name: SECTION.BENEFIT_NON_OCCUPATION_MEDICAL,
				path: '/benefit-non-occupate/medicalbenefit',
				pms_keys: EXTENDED_ROUTE_PMS.BENEFIT_NON_OCCUPATION_MEDICAL,
			},
			{
				name: SECTION.BENEFIT_NON_OCCUPATION_NO_REFUND,
				path: '/benefit-non-occupate/nonrefund',
				pms_keys: EXTENDED_ROUTE_PMS.BENEFIT_NON_OCCUPATION_NO_REFUND,
			},
		],
	},
	{
		name: SECTION.MAIN_BENEFIT_SHIPPING,
		key: 'BENEFIT_SHIPPING',
		icon: 'local_shipping',
		children: [
			{
				name: SECTION.BENEFIT_SHIPPING_FEE,
				path: '/shipping-benefit/shippingbenefit',
				pms_keys: EXTENDED_ROUTE_PMS.BENEFIT_SHIPPING_FEE,
			},
			{
				name: SECTION.BENEFIT_SHIPPING,
				path: '/shipping-benefit/shippinglist',
				pms_keys: EXTENDED_ROUTE_PMS.BENEFIT_SHIPPING,
			},
			{
				name: SECTION.BENEFIT_SHIPPING_DECISION,
				path: '/shipping-benefit/shippinggive',
				pms_keys: EXTENDED_ROUTE_PMS.BENEFIT_SHIPPING_DECISION,
			},
		],
	},
	{
		name: SECTION.WORK_ACTIVITY_REQUEST,
		key: 'WORK_ACTIVITY_REQUEST',
		icon: 'browser_updated',
		children: [
			{
				name: SECTION.WORK_ACTIVITY_REQUEST,
				path: '/work-activity',
				pms_keys: EXTENDED_ROUTE_PMS.WORK_ACTIVITY_REQUEST,
			},
		],
	},
	{
		name: SECTION.MAIN_BENEFIT_HEALTH_CARE,
		key: 'BENEFIT_HEALTH_CARE',
		icon: 'receipt_long',
		children: [
			{
				name: SECTION.BENEFIT_HEALTH_CARE_RECEIVER,
				path: '/healthcare-benefit/healthreceivebenefit',
				pms_keys: EXTENDED_ROUTE_PMS.BENEFIT_HEALTH_CARE_RECEIVER,
			},
			// {
			//   name: SECTION.BENEFIT_HEALTH_CARE_TRANSFER_DOC,
			//   path: '/healthcare-benefit/healthtransferdoc',
			//   pms_keys: EXTENDED_ROUTE_PMS.BENEFIT_HEALTH_CARE_TRANSFER_DOC,
			// },
			// {
			//   name: SECTION.BENEFIT_HEALTH_CARE_RECEIVED,
			//   path: '/healthcare-benefit/receivedbenefit',
			//   pms_keys: EXTENDED_ROUTE_PMS.BENEFIT_HEALTH_CARE_RECEIVED,
			// },
		],
	},
	{
		name: SECTION.HC,
		key: 'CLAIM_REQUEST_HC_DOC',
		icon: 'receipt_long',
		children: [
			{
				name: SECTION.HC_EMERGENCY_CLAIM_REQUEST_DOC,
				path: '/hospital-support/emergency',
				pms_keys: EXTENDED_ROUTE_PMS.EMERGENCY_CLAIM_REQUEST_HC,
			},
			{
				name: SECTION.HC_SICK_LEAVE_CLAIM_REQUEST_DOC,
				path: '/hospital-support/daily-allowance',
				pms_keys: EXTENDED_ROUTE_PMS.SICK_LEAVE_CLAIM_REQUEST_HC,
			},
			{
				name: SECTION.HC_DOCTOR_REPORT,
				path: '/hospital-support/doctor-report',
				pms_keys: EXTENDED_ROUTE_PMS.HC_DOCTOR_REPORT,
			},
		],
	},
	{
		name: SECTION.HC,
		key: 'HC_CLAIM_REQUEST',
		icon: 'receipt_long',
		children: [
			{
				name: SECTION.HC_EMERGENCY_CLAIM_REQUEST,
				path: '/healthcare-calculation/emergency',
				pms_keys: EXTENDED_ROUTE_PMS.HC_EMERGENCY_CLAIM_REQUEST,
			},
			{
				name: SECTION.HC_MATERNITY_CLAIM_REQUEST,
				path: '/healthcare-calculation/maternity',
				pms_keys: EXTENDED_ROUTE_PMS.HC_MATERNITY_CLAIM_REQUEST,
			},
			{
				name: SECTION.HC_SICK_LEAVE_CLAIM_REQUEST,
				path: '/healthcare-calculation/sick-leave',
				pms_keys: EXTENDED_ROUTE_PMS.HC_SICK_LEAVE_CLAIM_REQUEST,
			},
			{
				name: SECTION.HC_TRANSPORT_CLAIM_REQUEST,
				path: '/healthcare-calculation/transportion',
				pms_keys: EXTENDED_ROUTE_PMS.HC_TRANSPORT_CLAIM_REQUEST,
			},
			{
				name: SECTION.HC_FUNERAL_CLAIM_REQUEST,
				path: '/healthcare-calculation/funeral',
				pms_keys: EXTENDED_ROUTE_PMS.HC_FUNERAL_CLAIM_REQUEST,
			},
		],
	},
	{
		name: SECTION.BENEFIT_TABLE,
		key: 'BENEFIT_TABLE',
		icon: 'table_rows_narrow',
		children: [
			{
				name: SECTION.BENEFIT_TABLE,
				path: '/benefit-table',
				pms_keys: EXTENDED_ROUTE_PMS.BENEFIT_TABLE,
			},
		],
	},
	{
		name: SECTION.HC_BENEFIT_NOTE,
		key: 'HC_BENEFIT_NOTE',
		icon: 'receipt_long',
		children: [
			{
				name: SECTION.NOTE,
				path: '/healthcare-note/note',
				pms_keys: EXTENDED_ROUTE_PMS.NOTE,
			},
			{
				name: SECTION.PROVINCE_BRANCH_NOTE,
				path: '/healthcare-note/province-branch-note',
				pms_keys: EXTENDED_ROUTE_PMS.PROVINCE_BRANCH_NOTE,
			},
			{
				name: SECTION.NOTE_OVERALL,
				path: '/healthcare-note/daily-hc-note-overall',
				pms_keys: EXTENDED_ROUTE_PMS.DAILY_HC_NOTE_OVERALL,
			},
			{
				name: SECTION.APPROVAL,
				path: '/healthcare-note/request',
				pms_keys: EXTENDED_ROUTE_PMS.APPROVAL,
			},
			{
				name: SECTION.HC_NOTE_ADJUSTMENT,
				path: '/healthcare-note/adjustment',
				pms_keys: EXTENDED_ROUTE_PMS.NOTE_ADJUSTMENT,
			},
		],
	},
	{
		name: SECTION.BRANCH_NOTE_OVERALL,
		key: 'BRANCH_NOTE_OVERALL',
		icon: 'note_alt',
		children: [
			{
				name: SECTION.BRANCH_NOTE_OVERALL,
				path: '/overall-branch-note/request',
				pms_keys: EXTENDED_ROUTE_PMS.BRANCH_NOTE_OVERALL,
			},
			{
				name: SECTION.BRANCH_NOTE_RECEIVE,
				path: '/overall-branch-note/receive-request',
				pms_keys: EXTENDED_ROUTE_PMS.BRANCH_NOTE_RECEIVE,
			},
			{
				name: SECTION.BRANCH_NOTE_RESULT,
				path: '/overall-branch-note/branch-note-result',
				pms_keys: EXTENDED_ROUTE_PMS.BRANCH_NOTE_RESULT,
			},
		],
	},
	{
		name: SECTION.MAIN_NOTE_CONFIRM_OVERALL,
		key: 'WI_NOTE_CONFIRM_OVERALL',
		icon: 'note_alt',
		children: [
			{
				name: SECTION.WI_NOTE_OVERALL,
				path: '/overall-note-confirm/wi-note-confirm-overall',
				pms_keys: EXTENDED_ROUTE_PMS.WI_NOTE_CONFIRM_OVERALL,
			},
			{
				name: SECTION.HC_NOTE_OVERALL,
				path: '/overall-note-confirm/hc-note-confirm-overall',
				pms_keys: EXTENDED_ROUTE_PMS.HC_NOTE_CONFIRM_OVERALL,
			},
		],
	},
	{
		name: SECTION.SYSTEM_TRACKING,
		key: 'SYSTEM_TRACKING',
		icon: 'edit_notifications',
		children: [
			{
				name: SECTION.SYSTEM_TRACKING,
				path: '/tracking-system',
				pms_keys: EXTENDED_ROUTE_PMS.SYSTEM_TRACKING,
			},
		],
	},
	{
		name: SECTION.ROLE_TRANSFER,
		key: 'ROLE_TRANSFER',
		icon: 'connect_without_contact',
		children: [
			{
				name: SECTION.ROLE_TRANSFER,
				path: '/role-transfer',
				pms_keys: EXTENDED_ROUTE_PMS.ROLE_TRANSFER,
			},
		],
	},
	{
		name: SECTION.NSSF_USER,
		key: 'NSSF_USER',
		icon: 'manage_accounts',
		children: [
			{
				name: SECTION.NSSF_USER,
				path: '/user-admin',
				pms_keys: EXTENDED_ROUTE_PMS.NSSF_USER,
			},
		],
	},
	{
		name: SECTION.SETTING,
		key: 'SETTING',
		icon: 'settings',
		children: [
			{
				name: SECTION.SETTING,
				path: '/organization',
				pms_keys: EXTENDED_ROUTE_PMS.SETTING,
			},
		],
	},
	{
		name: SECTION.ALL_REPORT,
		key: 'ALL_REPORT',
		icon: 'reports',
		children: [
			{
				name: SECTION.REPORT,
				path: '/report/wi/claim-wi',
				pms_keys: [
					PERMISSION.READ_WI_CLAIM_REQ_REPORT,

				],
			},
			{
				name: SECTION.REPORT_ENTERPRISE,
				path: '/report/wi/officer-wi',
				pms_keys: [
					PERMISSION.READ_WI_CLAIM_AMOUNT_REPORT,

				],
			},
			{
				name: SECTION.REPORT_CLAIM_HC,
				path: '/report-hc/hc-claim',
				pms_keys: [
					PERMISSION.READ_HC_CLAIM_REQ_REPORT,

				],
			},
			{
				name: SECTION.REPORT_SUMMARY_TYPE,
				path: '/report-hc/summary',
				pms_keys: [
					PERMISSION.READ_HC_CLAIM_AMOUNT_REPORT,

				],
			},
		],
	},



];
